/* tslint:disable */
/* eslint-disable */
/**
 * FreebillService
 * REST-API for Freebill Services
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

export interface AbstractModel {
    'id'?: string;
}
export interface AbstractReadModel {
    'id'?: string;
}
export interface AddCommentForDraftCommand {
    'draftId'?: string;
    'userId'?: string;
    'comment'?: string | null;
}
export interface AddCommentForInvoiceCommand {
    'invoiceId'?: string;
    'userId'?: string;
    'comment'?: string | null;
}
export interface AddCommentForInvoiceReminderCommand {
    'invoiceReminderId'?: string;
    'userId'?: string;
    'comment'?: string | null;
}
export interface AddCommentForReverseInvoiceCommand {
    'reverseInvoiceId'?: string;
    'userId'?: string;
    'comment'?: string | null;
}
export interface AddCustomerCommand {
    'id'?: string | null;
    'userId'?: string;
    'company'?: Company;
    'textModel'?: TextModel;
    'ustId'?: string | null;
    'daysToDue'?: number | null;
}
export interface AddDraftCommand {
    'id'?: string | null;
    'invoiceType'?: InvoiceType;
    'userId'?: string;
    'invoiceDate'?: string;
    'invoiceRecipient'?: InvoiceRecipient;
    'textModel'?: TextModel;
    'numberRangeId'?: string;
    'invoiceItems'?: Array<InvoiceItem> | null;
    'dueDate'?: string | null;
}


export interface AddLogoCommand {
    'userId'?: string;
    'uploadedFileWithContent'?: UploadedFileWithContent;
}
export interface AddNumberRangeCommand {
    'userId'?: string;
    'name'?: string | null;
    'value'?: string | null;
    'firstNumber'?: number;
    'isDefault'?: boolean;
}
export interface AddProductCommand {
    'id'?: string | null;
    'userId'?: string;
    'productName'?: string | null;
    'price'?: number | null;
    'description'?: string | null;
    'tax_in_percent'?: number;
}
export interface AddTextModelCommand {
    'userId'?: string;
    'textModel'?: TextModel;
}
export interface AddTextModelEmailCommand {
    'userId'?: string;
    'textModelEmail'?: TextModelEmail;
}

export const AppId = {
    Fbl: 'FBL',
    Fff: 'FFF',
} as const;

export type AppId = typeof AppId[keyof typeof AppId];


export interface AuditTrailReadModel {
    'createdAt'?: string;
    'updatedAt'?: string;
    'id'?: string;
    'userId'?: string;
    'eventId'?: string;
    'eventOccuredAt'?: string;
    'eventName'?: string | null;
    'information'?: string | null;
}
export interface AuthenticationResult {
    'token'?: string | null;
    'userId'?: string | null;
    'authKey'?: string | null;
    'secondFactor'?: boolean;
    'errorMessages'?: Array<string> | null;
}
export interface BankAccount {
    'bankName'?: string | null;
    'accountOwner'?: string | null;
    'iban'?: string | null;
    'bic'?: string | null;
}
export interface BookInvoiceCommand {
    'correlationId'?: string;
    'userId'?: string;
    'invoiceType'?: InvoiceType;
    'invoiceItems'?: Array<InvoiceItem> | null;
    'invoiceDate'?: string;
    'invoiceNumber'?: string | null;
    'vehicleId'?: string;
    'invoiceRecipient'?: InvoiceRecipient;
    'uploadedFileId'?: string;
}


export interface BookReverseInvoiceCommand {
    'correlationId'?: string;
    'userId'?: string;
    'uploadedFileId'?: string;
}
export interface BookingInfo {
    'userId'?: string;
    'correlationId'?: string;
    'bookingType'?: BookingType;
    'taxInPercent'?: number;
    'bookingPeriodName'?: string | null;
    'bookingText'?: string | null;
    'amount'?: number;
    'bookingDate'?: string;
    'bookingNumber'?: number;
    'accountId'?: string;
    'reverseAccountId'?: string;
    'accountName'?: string | null;
    'reverseAccountName'?: string | null;
    'carId'?: string | null;
    'carName'?: string | null;
    'businessPartnerId'?: string | null;
    'businessPartnerName'?: string | null;
    'businessPartnerUstId'?: string | null;
}


export interface BookingPeriod {
    'name'?: string | null;
    'startDate'?: string | null;
    'endDate'?: string | null;
}

export const BookingType = {
    Soll: 'SOLL',
    Haben: 'HABEN',
} as const;

export type BookingType = typeof BookingType[keyof typeof BookingType];


export interface CancelInvoiceCommand {
    'id'?: string;
    'userId'?: string;
}
export interface CarReadModel {
    'id'?: string;
    'userId'?: string;
    'licensePlate'?: string | null;
    'carType'?: string | null;
}
export interface ChangeBookingPeriodCommand {
    'userId'?: string;
    'bookingPeriod'?: BookingPeriod;
}
export interface Company {
    'companyName'?: string | null;
    'additionalAddress'?: string | null;
    'street'?: string | null;
    'postCode'?: string | null;
    'city'?: string | null;
    'country'?: string | null;
    'email'?: string | null;
    'localCourt'?: string | null;
    'hrbNumber'?: string | null;
    'managingDirector'?: string | null;
    'website'?: string | null;
}
export interface ConfigureMailServiceCommand {
    'userId'?: string;
    'mailServiceConfig'?: MailServiceConfig;
}
export interface Contact {
    'gender'?: Gender;
    'lastName'?: string | null;
    'firstName'?: string | null;
    'email'?: string | null;
    'phone'?: string | null;
}


export interface CreateAndSendInvoiceCommand {
    'invoiceType'?: InvoiceType;
    'userId'?: string;
    'invoiceDate'?: string;
    'invoiceRecipient'?: InvoiceRecipient;
    'textModel'?: TextModel;
    'invoiceItems'?: Array<InvoiceItem> | null;
    'dueDate'?: string | null;
    'isAlreadyPaid'?: boolean;
    'emailText'?: string | null;
    'salutationName'?: string | null;
}


export interface CreateInvoiceCommand {
    'invoiceType'?: InvoiceType;
    'userId'?: string;
    'invoiceDate'?: string;
    'invoiceRecipient'?: InvoiceRecipient;
    'textModel'?: TextModel;
    'numberRangeId'?: string;
    'invoiceItems'?: Array<InvoiceItem> | null;
    'dueDate'?: string | null;
    'isAlreadyPaid'?: boolean;
}


export interface CreateInvoicePreviewCommand {
    'invoiceType'?: InvoiceType;
    'userId'?: string;
    'invoiceDate'?: string;
    'invoiceRecipient'?: InvoiceRecipient;
    'textModel'?: TextModel;
    'numberRangeId'?: string;
    'invoiceItems'?: Array<InvoiceItem> | null;
    'dueDate'?: string | null;
}


export interface CreateInvoiceReminderCommand {
    'id'?: string;
    'userId'?: string;
    'subject'?: string | null;
    'message'?: string | null;
}
export interface CreateOrFixTaxNumberCommand {
    'userId'?: string;
    'federalState'?: FederalState;
    'taxNumber'?: string | null;
}



export const CreateOrFixTaxNumberResult = {
    FederalStateMissing: 'FEDERAL_STATE_MISSING',
    TaxNumberInvalid: 'TAX_NUMBER_INVALID',
    TaxNumberChanged: 'TAX_NUMBER_CHANGED',
    TaxNumberValid: 'TAX_NUMBER_VALID',
} as const;

export type CreateOrFixTaxNumberResult = typeof CreateOrFixTaxNumberResult[keyof typeof CreateOrFixTaxNumberResult];


export interface CreateReverseInvoicePreviewCommand {
    'canceledInvoiceId'?: string;
}
export interface CustomerAnalysis {
    'customerName'?: string | null;
    'totalInvoices'?: number | null;
    'totalInvoiceReminders'?: number | null;
    'totalReverseInvoices'?: number | null;
    'totalNetAmount'?: number;
    'totalTaxAmount'?: number;
    'totalGrossAmount'?: number;
}
export interface CustomerReadModel {
    'createdAt'?: string;
    'updatedAt'?: string;
    'id'?: string;
    'userId'?: string;
    'ustId'?: string | null;
    'company'?: Company;
    'textModel'?: TextModel;
}
export interface DraftReadModel {
    'createdAt'?: string;
    'updatedAt'?: string;
    'id'?: string;
    'logoAsBase64'?: string | null;
    'invoiceType'?: InvoiceType;
    'invoiceDate'?: string;
    'numberRangeId'?: string;
    'userId'?: string;
    'showFreeLogo'?: boolean | null;
    'containsItemWithDiscount'?: boolean;
    'invoiceItems'?: Array<InvoiceItem> | null;
    'invoiceIssuer'?: InvoiceIssuer;
    'invoiceRecipient'?: InvoiceRecipient;
    'textModel'?: TextModel;
    'dueDate'?: string | null;
    'grossAmount'?: number;
    'taxAmounts'?: Array<TaxAmount> | null;
    'taxAmount'?: number;
    'netAmount'?: number;
    'comments'?: Array<string> | null;
}


export interface ExpenditureAccountReadModel {
    'id'?: string;
    'userId'?: string;
    'name'?: string | null;
    'taxes'?: Array<Tax> | null;
    'isVehicleAccount'?: boolean;
}

export const FederalState = {
    BadenWuerttemberg: 'BADEN_WUERTTEMBERG',
    Bayern: 'BAYERN',
    Berlin: 'BERLIN',
    Brandenburg: 'BRANDENBURG',
    Bremen: 'BREMEN',
    Hamburg: 'HAMBURG',
    Hessen: 'HESSEN',
    MecklenburgVorpommern: 'MECKLENBURG_VORPOMMERN',
    Niedersachsen: 'NIEDERSACHSEN',
    Nrw: 'NRW',
    RheinlandPfalz: 'RHEINLAND_PFALZ',
    Saarland: 'SAARLAND',
    Sachsen: 'SACHSEN',
    SachsenAnhalt: 'SACHSEN_ANHALT',
    SchleswigHolstein: 'SCHLESWIG_HOLSTEIN',
    Thueringen: 'THUERINGEN',
} as const;

export type FederalState = typeof FederalState[keyof typeof FederalState];



export const FileType = {
    Picture: 'Picture',
    Pdf: 'Pdf',
} as const;

export type FileType = typeof FileType[keyof typeof FileType];



export const Gender = {
    Male: 'Male',
    Female: 'Female',
} as const;

export type Gender = typeof Gender[keyof typeof Gender];


export interface GetXmlInvoiceFromFileQuery {
    'fileContentAsBase64'?: string | null;
    'mimeType'?: string | null;
}
export interface ImportUserCommand {
    'id'?: string | null;
    'isSmallBusiness'?: boolean;
    'taxNumber'?: string | null;
    'federalState'?: FederalState;
    'defaultDuePeriod'?: number | null;
    'company'?: Company;
    'contact'?: Contact;
    'bookingPeriod'?: BookingPeriod;
}


export interface InvoiceIssuer {
    'company'?: Company;
    'contact'?: Contact;
    'bankAccount'?: BankAccount;
    'isSmallBusiness'?: boolean;
    'taxInfo'?: string | null;
}
export interface InvoiceItem {
    'itemName'?: string | null;
    'description'?: string | null;
    'quantity'?: number;
    'discount_in_percent'?: number | null;
    'price'?: number;
    'tax_in_percent'?: number;
    'totalAmount'?: number | null;
    'totalNetAmount'?: number | null;
}
export interface InvoiceReadModel {
    'createdAt'?: string;
    'updatedAt'?: string;
    'id'?: string;
    'logoAsBase64'?: string | null;
    'invoiceType'?: InvoiceType;
    'invoiceDate'?: string;
    'numberRangeId'?: string;
    'userId'?: string;
    'showFreeLogo'?: boolean | null;
    'containsItemWithDiscount'?: boolean;
    'invoiceItems'?: Array<InvoiceItem> | null;
    'invoiceIssuer'?: InvoiceIssuer;
    'invoiceRecipient'?: InvoiceRecipient;
    'textModel'?: TextModel;
    'dueDate'?: string | null;
    'grossAmount'?: number;
    'taxAmounts'?: Array<TaxAmount> | null;
    'taxAmount'?: number;
    'netAmount'?: number;
    'comments'?: Array<string> | null;
    'isSendByMail'?: boolean;
    'correlationId'?: string;
    'invoiceNumber'?: string | null;
    'invoiceState'?: InvoiceState;
    'canceledInvoiceId'?: string | null;
    'isCanceled'?: boolean;
    'bookingInfos'?: Array<BookingInfo> | null;
    'uploadedFileId'?: string;
    'reminderStepNumber'?: number | null;
}


export interface InvoiceRecipient {
    'id'?: string | null;
    'company'?: Company;
    'ustId'?: string | null;
}
export interface InvoiceReminderReadModel {
    'createdAt'?: string;
    'updatedAt'?: string;
    'id'?: string;
    'userId'?: string;
    'showFreeLogo'?: boolean | null;
    'logoAsBase64'?: string | null;
    'invoiceIssuer'?: InvoiceIssuer;
    'invoiceRecipient'?: InvoiceRecipient;
    'invoiceReminderDate'?: string;
    'dueDate'?: string | null;
    'invoiceId'?: string;
    'correlationId'?: string;
    'textModel'?: TextModel;
    'isSendByMail'?: boolean;
    'uploadedFileId'?: string;
    'comments'?: Array<string> | null;
}

export const InvoiceState = {
    Pending: 'Pending',
    Paid: 'Paid',
    PastDue: 'PastDue',
    Failed: 'Failed',
    Canceled: 'Canceled',
} as const;

export type InvoiceState = typeof InvoiceState[keyof typeof InvoiceState];



export const InvoiceType = {
    StandardInvoice: 'StandardInvoice',
    EuInvoiceService: 'EuInvoiceService',
    EuInvoiceDelivery: 'EuInvoiceDelivery',
    ThirdCountryInvoiceService: 'ThirdCountryInvoiceService',
    ThirdCountryInvoiceDelivery: 'ThirdCountryInvoiceDelivery',
    Revenues13bInvoice: 'Revenues13bInvoice',
    SaleCarInvoice: 'SaleCarInvoice',
    SaleCapitalAssetsInvoice: 'SaleCapitalAssetsInvoice',
    ReverseInvoice: 'ReverseInvoice',
} as const;

export type InvoiceType = typeof InvoiceType[keyof typeof InvoiceType];


export interface Login2FaCommand {
    'userId'?: string | null;
    'authKey'?: string | null;
    'secondFactor'?: string | null;
    'sessionId'?: string | null;
}
export interface LoginCommand {
    'username'?: string | null;
    'password'?: string | null;
    'sessionId'?: string | null;
}
export interface LogoutCommand {
    'userId'?: string;
    'sessionId'?: string;
}
export interface MailServiceConfig {
    'email'?: string | null;
    'sender'?: string | null;
    'username'?: string | null;
    'password'?: string | null;
    'host'?: string | null;
    'port'?: number;
    'useSsl'?: boolean;
}
export interface MailServiceConfigTestQuery {
    'userId'?: string;
    'toAddress'?: string | null;
}
export interface MarkInvoiceAsPaidCommand {
    'id'?: string;
    'userId'?: string;
}
export interface MarkInvoiceAsPastDueCommand {
    'id'?: string;
    'userId'?: string;
}
export interface MarkInvoiceAsPendingCommand {
    'id'?: string;
    'userId'?: string;
}
export interface NumberRangeReadModel {
    'createdAt'?: string;
    'updatedAt'?: string;
    'id'?: string;
    'userId'?: string;
    'name'?: string | null;
    'value'?: string | null;
    'firstNumber'?: number;
    'nextNumber'?: number;
    'isDefault'?: boolean;
}
export interface OrderSubscriptionCommand {
    'appId'?: AppId;
    'userId'?: string;
    'email'?: string | null;
    'callbackUrl'?: string | null;
    'fullName'?: string | null;
    'companyName'?: string | null;
    'city'?: string | null;
    'streetNameAndNumber'?: string | null;
    'postCode'?: string | null;
}


export interface ProblemDetails {
    [key: string]: any;

    'type'?: string | null;
    'title'?: string | null;
    'status'?: number | null;
    'detail'?: string | null;
    'instance'?: string | null;
}
export interface ProductReadModel {
    'createdAt'?: string;
    'updatedAt'?: string;
    'id'?: string;
    'userId'?: string;
    'tax_in_percent'?: number;
    'productName'?: string | null;
    'description'?: string | null;
    'price'?: number | null;
}
export interface RegisterCommand {
    'ipAddress'?: string | null;
    'email'?: string | null;
    'backlinkUrl'?: string | null;
    'isNewsletterAccepted'?: boolean | null;
}
export interface RemoveCommentForDraftCommand {
    'draftId'?: string;
    'userId'?: string;
    'index'?: number;
}
export interface RemoveCommentForInvoiceCommand {
    'invoiceId'?: string;
    'userId'?: string;
    'index'?: number;
}
export interface RemoveCommentForInvoiceReminderCommand {
    'invoiceReminderId'?: string;
    'userId'?: string;
    'index'?: number;
}
export interface RemoveCommentForReverseInvoiceCommand {
    'reverseInvoiceId'?: string;
    'userId'?: string;
    'index'?: number;
}
export interface RemoveLogoCommand {
    'id'?: string;
    'userId'?: string;
}
export interface RemoveMailServiceConfigurationCommand {
    'userId'?: string;
}
export interface RemoveTextModelCommand {
    'userId'?: string;
}
export interface RemoveTextModelEmailCommand {
    'userId'?: string;
}
export interface ResetPasswordCommand {
    'resetHash'?: string | null;
    'newPassword'?: string | null;
}
export interface RevenuesAccountReadModel {
    'id'?: string;
    'userId'?: string;
    'name'?: string | null;
    'taxes'?: Array<Tax> | null;
    'isVehicleAccount'?: boolean;
}
export interface ReverseInvoiceReadModel {
    'createdAt'?: string;
    'updatedAt'?: string;
    'id'?: string;
    'logoAsBase64'?: string | null;
    'invoiceDate'?: string;
    'userId'?: string;
    'showFreeLogo'?: boolean | null;
    'containsItemWithDiscount'?: boolean;
    'invoiceItems'?: Array<InvoiceItem> | null;
    'invoiceIssuer'?: InvoiceIssuer;
    'invoiceRecipient'?: InvoiceRecipient;
    'textModel'?: TextModel;
    'grossAmount'?: number;
    'taxAmounts'?: Array<TaxAmount> | null;
    'taxAmount'?: number;
    'netAmount'?: number;
    'isSendByMail'?: boolean;
    'invoiceNumber'?: string | null;
    'canceledInvoiceId'?: string | null;
    'correlationId'?: string | null;
    'bookingInfos'?: Array<BookingInfo> | null;
    'uploadedFileId'?: string;
    'comments'?: Array<string> | null;
}
export interface SendInvoiceByMailCommand {
    'id'?: string;
    'userId'?: string;
    'fromAddress'?: string | null;
    'fromName'?: string | null;
    'toAddresses'?: Array<string> | null;
    'toCCAddresses'?: Array<string> | null;
    'toBCCAddresses'?: Array<string> | null;
    'toName'?: string | null;
    'subject'?: string | null;
    'emailText'?: string | null;
}
export interface SendInvoiceReminderByMailCommand {
    'id'?: string;
    'invoiceId'?: string;
    'userId'?: string;
    'fromAddress'?: string | null;
    'fromName'?: string | null;
    'toAddresses'?: Array<string> | null;
    'toCCAddresses'?: Array<string> | null;
    'toBCCAddresses'?: Array<string> | null;
    'toName'?: string | null;
    'subject'?: string | null;
    'emailText'?: string | null;
}
export interface SendPasswordResetMailCommand {
    'username'?: string | null;
    'backlinkUrl'?: string | null;
}
export interface SendReverseInvoiceByMailCommand {
    'id'?: string;
    'userId'?: string;
    'fromAddress'?: string | null;
    'fromName'?: string | null;
    'toAddresses'?: Array<string> | null;
    'toCCAddresses'?: Array<string> | null;
    'toBCCAddresses'?: Array<string> | null;
    'toName'?: string | null;
    'subject'?: string | null;
    'emailText'?: string | null;
    'invoiceId'?: string;
}
export interface SetNumberRangeToDefaultCommand {
    'id'?: string;
    'userId'?: string;
}
export interface SetupUserLoginCommand {
    'activationId'?: string | null;
    'activationKey'?: string | null;
    'username'?: string | null;
    'password'?: string | null;
    'sessionId'?: string | null;
}
export interface SetupUserLoginResult {
    'token'?: string | null;
    'errorMessages'?: Array<string> | null;
}

export const SortDirection = {
    Ascending: 'Ascending',
    Descending: 'Descending',
} as const;

export type SortDirection = typeof SortDirection[keyof typeof SortDirection];


export interface Tax {
    'key'?: string | null;
    'value'?: number;
}
export interface TaxAmount {
    'name'?: string | null;
    'amount'?: number;
    'netBasisAmount'?: number | null;
    'taxInPercent'?: number | null;
}
export interface TextModel {
    'heading'?: string | null;
    'introduction'?: string | null;
    'isSmallBusinessNotice'?: string | null;
    'reverseChargeNotice'?: string | null;
    'recipientUstIdNotice'?: string | null;
    'deliveryDateNotice'?: string | null;
    'dueDemand'?: string | null;
    'terms'?: string | null;
    'ending'?: string | null;
}
export interface TextModelEmail {
    'sendInvoiceEmailText'?: string | null;
    'sendReverseInvoiceEmailText'?: string | null;
    'sendInvoiceReminderEmailTextStep1'?: string | null;
    'sendInvoiceReminderEmailTextStep2'?: string | null;
    'sendInvoiceReminderEmailTextStep3'?: string | null;
    'sendInvoiceSubjectText'?: string | null;
    'sendReverseInvoiceSubjectText'?: string | null;
    'sendInvoiceReminderSubjectTextStep1'?: string | null;
    'sendInvoiceReminderSubjectTextStep2'?: string | null;
    'sendInvoiceReminderSubjectTextStep3'?: string | null;
}
export interface TotalAmountCategory {
    'name'?: string | null;
    'totalInvoices'?: number;
    'totalNetAmount'?: number;
    'totalGrossAmount'?: number;
    'totalTaxAmount'?: number;
}
export interface TotalInvoiceAmounts {
    'totalNetAmount'?: number;
    'totalTaxAmount'?: number;
    'totalGrossAmount'?: number;
    'totalInvoices'?: number | null;
    'totalAmountCategories'?: Array<TotalAmountCategory> | null;
    'month'?: number | null;
    'year'?: number | null;
}
export interface UpdateCustomerCommand {
    'id'?: string;
    'company'?: Company;
    'textModel'?: TextModel;
    'ustId'?: string | null;
    'daysToDue'?: number | null;
}
export interface UpdateNumberRangeCommand {
    'id'?: string;
    'userId'?: string;
    'name'?: string | null;
    'value'?: string | null;
    'firstNumber'?: number;
    'isDefault'?: boolean;
}
export interface UpdateProductCommand {
    'id'?: string;
    'productName'?: string | null;
    'description'?: string | null;
    'price'?: number | null;
    'tax_in_percent'?: number;
}
export interface UpdateUserCommand {
    'id'?: string;
    'company'?: Company;
    'contact'?: Contact;
    'bankAccount'?: BankAccount;
    'isSmallBusiness'?: boolean;
    'taxNumber'?: string | null;
    'federalState'?: FederalState;
    'ustId'?: string | null;
    'isUstIdHidden'?: boolean;
    'defaultDuePeriod'?: number | null;
}


export interface UploadedFile {
    'id'?: string;
    'freeBillInvoiceCorrelationId'?: string | null;
    'userId'?: string;
    'fileName'?: string | null;
    'fileUrl'?: string | null;
    'fileType'?: FileType;
    'createdAt'?: string;
    'updatedAt'?: string;
}


export interface UploadedFileWithContent {
    'id'?: string;
    'freeBillInvoiceCorrelationId'?: string | null;
    'userId'?: string;
    'fileName'?: string | null;
    'fileUrl'?: string | null;
    'fileType'?: FileType;
    'createdAt'?: string;
    'updatedAt'?: string;
    'fileContentAsBase64'?: string | null;
    'mimeType'?: string | null;
}


export interface UserReadModel {
    'id'?: string;
    'userId'?: string;
    'logo'?: UploadedFile;
    'company'?: Company;
    'contact'?: Contact;
    'bankAccount'?: BankAccount;
    'mailServiceConfig'?: MailServiceConfig;
    'textModel'?: TextModel;
    'textModelEmail'?: TextModelEmail;
    'isSmallBusiness'?: boolean;
    'defaultDuePeriod'?: number | null;
    'taxNumber'?: string | null;
    'federalState'?: string | null;
    'ustId'?: string | null;
    'isUstIdHidden'?: boolean;
    'bookingPeriod'?: BookingPeriod;
    'createdAt'?: string;
    'updatedAt'?: string;
}
export interface XmlInvoiceDto {
    'invoiceNumber'?: string | null;
    'dueDate'?: string | null;
    'invoiceDate'?: string | null;
    'recipient'?: InvoiceRecipient;
    'issuer'?: InvoiceIssuer;
    'textModel'?: TextModel;
    'items'?: Array<XmlItem> | null;
    'taxes'?: Array<XmlTax> | null;
    'grossAmount'?: number;
    'netAmount'?: number;
    'taxAmount'?: number;
}
export interface XmlItem {
    'name'?: string | null;
    'description'?: string | null;
    'price'?: number;
    'quantity'?: number;
    'lineTotalAmount'?: number;
    'taxInPercent'?: number;
}
export interface XmlTax {
    'taxInPercent'?: number;
    'netBasisAmount'?: number;
    'taxAmount'?: number;
}

/**
 * AuditTrailApi - axios parameter creator
 */
export const AuditTrailApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllByEventId: async (eventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('getAllByEventId', 'eventId', eventId)
            const localVarPath = `/api/v1/AuditTrail/{eventId}`
                .replace('{eventId}', encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {object} [filter] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [sortAttribute] 
         * @param {SortDirection} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuditTrails: async (filter?: object, pageNumber?: number, pageSize?: number, sortAttribute?: string, sortDirection?: SortDirection, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/AuditTrail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filter !== undefined) {
                for (const [key, value] of Object.entries(filter)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['PageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['PageSize'] = pageSize;
            }

            if (sortAttribute !== undefined) {
                localVarQueryParameter['SortAttribute'] = sortAttribute;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['SortDirection'] = sortDirection;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuditTrailApi - functional programming interface
 */
export const AuditTrailApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuditTrailApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllByEventId(eventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AuditTrailReadModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllByEventId(eventId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditTrailApi.getAllByEventId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {object} [filter] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [sortAttribute] 
         * @param {SortDirection} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAuditTrails(filter?: object, pageNumber?: number, pageSize?: number, sortAttribute?: string, sortDirection?: SortDirection, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AuditTrailReadModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAuditTrails(filter, pageNumber, pageSize, sortAttribute, sortDirection, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditTrailApi.getAuditTrails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AuditTrailApi - factory interface
 */
export const AuditTrailApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuditTrailApiFp(configuration)
    return {
        /**
         * 
         * @param {AuditTrailApiGetAllByEventIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllByEventId(requestParameters: AuditTrailApiGetAllByEventIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AuditTrailReadModel>> {
            return localVarFp.getAllByEventId(requestParameters.eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AuditTrailApiGetAuditTrailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuditTrails(requestParameters: AuditTrailApiGetAuditTrailsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<AuditTrailReadModel>> {
            return localVarFp.getAuditTrails(requestParameters.filter, requestParameters.pageNumber, requestParameters.pageSize, requestParameters.sortAttribute, requestParameters.sortDirection, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getAllByEventId operation in AuditTrailApi.
 */
export interface AuditTrailApiGetAllByEventIdRequest {
    readonly eventId: string
}

/**
 * Request parameters for getAuditTrails operation in AuditTrailApi.
 */
export interface AuditTrailApiGetAuditTrailsRequest {
    readonly filter?: object

    readonly pageNumber?: number

    readonly pageSize?: number

    readonly sortAttribute?: string

    readonly sortDirection?: SortDirection
}

/**
 * AuditTrailApi - object-oriented interface
 */
export class AuditTrailApi extends BaseAPI {
    /**
     * 
     * @param {AuditTrailApiGetAllByEventIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAllByEventId(requestParameters: AuditTrailApiGetAllByEventIdRequest, options?: RawAxiosRequestConfig) {
        return AuditTrailApiFp(this.configuration).getAllByEventId(requestParameters.eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AuditTrailApiGetAuditTrailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAuditTrails(requestParameters: AuditTrailApiGetAuditTrailsRequest = {}, options?: RawAxiosRequestConfig) {
        return AuditTrailApiFp(this.configuration).getAuditTrails(requestParameters.filter, requestParameters.pageNumber, requestParameters.pageSize, requestParameters.sortAttribute, requestParameters.sortDirection, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CarsApi - axios parameter creator
 */
export const CarsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [userId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCars: async (userId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Cars`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CarsApi - functional programming interface
 */
export const CarsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CarsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [userId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCars(userId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CarReadModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCars(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CarsApi.getCars']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CarsApi - factory interface
 */
export const CarsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CarsApiFp(configuration)
    return {
        /**
         * 
         * @param {CarsApiGetCarsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCars(requestParameters: CarsApiGetCarsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<CarReadModel>> {
            return localVarFp.getCars(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getCars operation in CarsApi.
 */
export interface CarsApiGetCarsRequest {
    readonly userId?: string
}

/**
 * CarsApi - object-oriented interface
 */
export class CarsApi extends BaseAPI {
    /**
     * 
     * @param {CarsApiGetCarsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCars(requestParameters: CarsApiGetCarsRequest = {}, options?: RawAxiosRequestConfig) {
        return CarsApiFp(this.configuration).getCars(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CustomersApi - axios parameter creator
 */
export const CustomersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {AddCustomerCommand} [addCustomerCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCustomer: async (addCustomerCommand?: AddCustomerCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Customers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addCustomerCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerAnalysisById: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCustomerAnalysisById', 'id', id)
            const localVarPath = `/api/v1/Customers/{id}/Analysis`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerAnalysisList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Customers/Analysis`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerById: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCustomerById', 'id', id)
            const localVarPath = `/api/v1/Customers/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [companyNameContains] 
         * @param {string} [contactEmailContains] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [sortAttribute] 
         * @param {SortDirection} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomers: async (companyNameContains?: string, contactEmailContains?: string, pageNumber?: number, pageSize?: number, sortAttribute?: string, sortDirection?: SortDirection, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Customers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (companyNameContains !== undefined) {
                localVarQueryParameter['CompanyName_Contains'] = companyNameContains;
            }

            if (contactEmailContains !== undefined) {
                localVarQueryParameter['ContactEmail_Contains'] = contactEmailContains;
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['PageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['PageSize'] = pageSize;
            }

            if (sortAttribute !== undefined) {
                localVarQueryParameter['SortAttribute'] = sortAttribute;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['SortDirection'] = sortDirection;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeCustomer: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('removeCustomer', 'id', id)
            const localVarPath = `/api/v1/Customers/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateCustomerCommand} [updateCustomerCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomer: async (id: string, updateCustomerCommand?: UpdateCustomerCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateCustomer', 'id', id)
            const localVarPath = `/api/v1/Customers/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCustomerCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomersApi - functional programming interface
 */
export const CustomersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {AddCustomerCommand} [addCustomerCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addCustomer(addCustomerCommand?: AddCustomerCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AbstractReadModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addCustomer(addCustomerCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.addCustomer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomerAnalysisById(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerAnalysis>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomerAnalysisById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.getCustomerAnalysisById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomerAnalysisList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CustomerAnalysis>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomerAnalysisList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.getCustomerAnalysisList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomerById(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerReadModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomerById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.getCustomerById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [companyNameContains] 
         * @param {string} [contactEmailContains] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [sortAttribute] 
         * @param {SortDirection} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomers(companyNameContains?: string, contactEmailContains?: string, pageNumber?: number, pageSize?: number, sortAttribute?: string, sortDirection?: SortDirection, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CustomerReadModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomers(companyNameContains, contactEmailContains, pageNumber, pageSize, sortAttribute, sortDirection, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.getCustomers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeCustomer(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerReadModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeCustomer(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.removeCustomer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateCustomerCommand} [updateCustomerCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCustomer(id: string, updateCustomerCommand?: UpdateCustomerCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerReadModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCustomer(id, updateCustomerCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.updateCustomer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CustomersApi - factory interface
 */
export const CustomersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomersApiFp(configuration)
    return {
        /**
         * 
         * @param {CustomersApiAddCustomerRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCustomer(requestParameters: CustomersApiAddCustomerRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AbstractReadModel> {
            return localVarFp.addCustomer(requestParameters.addCustomerCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CustomersApiGetCustomerAnalysisByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerAnalysisById(requestParameters: CustomersApiGetCustomerAnalysisByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<CustomerAnalysis> {
            return localVarFp.getCustomerAnalysisById(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerAnalysisList(options?: RawAxiosRequestConfig): AxiosPromise<Array<CustomerAnalysis>> {
            return localVarFp.getCustomerAnalysisList(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CustomersApiGetCustomerByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerById(requestParameters: CustomersApiGetCustomerByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<CustomerReadModel> {
            return localVarFp.getCustomerById(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CustomersApiGetCustomersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomers(requestParameters: CustomersApiGetCustomersRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<CustomerReadModel>> {
            return localVarFp.getCustomers(requestParameters.companyNameContains, requestParameters.contactEmailContains, requestParameters.pageNumber, requestParameters.pageSize, requestParameters.sortAttribute, requestParameters.sortDirection, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CustomersApiRemoveCustomerRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeCustomer(requestParameters: CustomersApiRemoveCustomerRequest, options?: RawAxiosRequestConfig): AxiosPromise<CustomerReadModel> {
            return localVarFp.removeCustomer(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CustomersApiUpdateCustomerRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomer(requestParameters: CustomersApiUpdateCustomerRequest, options?: RawAxiosRequestConfig): AxiosPromise<CustomerReadModel> {
            return localVarFp.updateCustomer(requestParameters.id, requestParameters.updateCustomerCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for addCustomer operation in CustomersApi.
 */
export interface CustomersApiAddCustomerRequest {
    readonly addCustomerCommand?: AddCustomerCommand
}

/**
 * Request parameters for getCustomerAnalysisById operation in CustomersApi.
 */
export interface CustomersApiGetCustomerAnalysisByIdRequest {
    readonly id: string
}

/**
 * Request parameters for getCustomerById operation in CustomersApi.
 */
export interface CustomersApiGetCustomerByIdRequest {
    readonly id: string
}

/**
 * Request parameters for getCustomers operation in CustomersApi.
 */
export interface CustomersApiGetCustomersRequest {
    readonly companyNameContains?: string

    readonly contactEmailContains?: string

    readonly pageNumber?: number

    readonly pageSize?: number

    readonly sortAttribute?: string

    readonly sortDirection?: SortDirection
}

/**
 * Request parameters for removeCustomer operation in CustomersApi.
 */
export interface CustomersApiRemoveCustomerRequest {
    readonly id: string
}

/**
 * Request parameters for updateCustomer operation in CustomersApi.
 */
export interface CustomersApiUpdateCustomerRequest {
    readonly id: string

    readonly updateCustomerCommand?: UpdateCustomerCommand
}

/**
 * CustomersApi - object-oriented interface
 */
export class CustomersApi extends BaseAPI {
    /**
     * 
     * @param {CustomersApiAddCustomerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addCustomer(requestParameters: CustomersApiAddCustomerRequest = {}, options?: RawAxiosRequestConfig) {
        return CustomersApiFp(this.configuration).addCustomer(requestParameters.addCustomerCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CustomersApiGetCustomerAnalysisByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCustomerAnalysisById(requestParameters: CustomersApiGetCustomerAnalysisByIdRequest, options?: RawAxiosRequestConfig) {
        return CustomersApiFp(this.configuration).getCustomerAnalysisById(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCustomerAnalysisList(options?: RawAxiosRequestConfig) {
        return CustomersApiFp(this.configuration).getCustomerAnalysisList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CustomersApiGetCustomerByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCustomerById(requestParameters: CustomersApiGetCustomerByIdRequest, options?: RawAxiosRequestConfig) {
        return CustomersApiFp(this.configuration).getCustomerById(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CustomersApiGetCustomersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCustomers(requestParameters: CustomersApiGetCustomersRequest = {}, options?: RawAxiosRequestConfig) {
        return CustomersApiFp(this.configuration).getCustomers(requestParameters.companyNameContains, requestParameters.contactEmailContains, requestParameters.pageNumber, requestParameters.pageSize, requestParameters.sortAttribute, requestParameters.sortDirection, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CustomersApiRemoveCustomerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public removeCustomer(requestParameters: CustomersApiRemoveCustomerRequest, options?: RawAxiosRequestConfig) {
        return CustomersApiFp(this.configuration).removeCustomer(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CustomersApiUpdateCustomerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateCustomer(requestParameters: CustomersApiUpdateCustomerRequest, options?: RawAxiosRequestConfig) {
        return CustomersApiFp(this.configuration).updateCustomer(requestParameters.id, requestParameters.updateCustomerCommand, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DraftsApi - axios parameter creator
 */
export const DraftsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} draftId 
         * @param {AddCommentForDraftCommand} [addCommentForDraftCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCommentForDraft: async (draftId: string, addCommentForDraftCommand?: AddCommentForDraftCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'draftId' is not null or undefined
            assertParamExists('addCommentForDraft', 'draftId', draftId)
            const localVarPath = `/api/v1/Drafts/{draftId}/AddCommentForDraft`
                .replace('{draftId}', encodeURIComponent(String(draftId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addCommentForDraftCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AddDraftCommand} [addDraftCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDraft: async (addDraftCommand?: AddDraftCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Drafts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addDraftCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDraftById: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getDraftById', 'id', id)
            const localVarPath = `/api/v1/Drafts/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [companyNameContains] 
         * @param {number} [grossAmountGt] 
         * @param {number} [grossAmountLt] 
         * @param {string} [dueDateGt] 
         * @param {string} [dueDateLt] 
         * @param {Array<string>} [numberRangeIdEq] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [sortAttribute] 
         * @param {SortDirection} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDrafts: async (companyNameContains?: string, grossAmountGt?: number, grossAmountLt?: number, dueDateGt?: string, dueDateLt?: string, numberRangeIdEq?: Array<string>, pageNumber?: number, pageSize?: number, sortAttribute?: string, sortDirection?: SortDirection, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Drafts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (companyNameContains !== undefined) {
                localVarQueryParameter['CompanyName_Contains'] = companyNameContains;
            }

            if (grossAmountGt !== undefined) {
                localVarQueryParameter['GrossAmount_Gt'] = grossAmountGt;
            }

            if (grossAmountLt !== undefined) {
                localVarQueryParameter['GrossAmount_Lt'] = grossAmountLt;
            }

            if (dueDateGt !== undefined) {
                localVarQueryParameter['DueDate_Gt'] = (dueDateGt as any instanceof Date) ?
                    (dueDateGt as any).toISOString() :
                    dueDateGt;
            }

            if (dueDateLt !== undefined) {
                localVarQueryParameter['DueDate_Lt'] = (dueDateLt as any instanceof Date) ?
                    (dueDateLt as any).toISOString() :
                    dueDateLt;
            }

            if (numberRangeIdEq) {
                localVarQueryParameter['NumberRangeId_Eq'] = numberRangeIdEq;
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['PageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['PageSize'] = pageSize;
            }

            if (sortAttribute !== undefined) {
                localVarQueryParameter['SortAttribute'] = sortAttribute;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['SortDirection'] = sortDirection;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [companyNameContains] 
         * @param {number} [grossAmountGt] 
         * @param {number} [grossAmountLt] 
         * @param {string} [dueDateGt] 
         * @param {string} [dueDateLt] 
         * @param {Array<string>} [numberRangeIdEq] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [sortAttribute] 
         * @param {SortDirection} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTotalDraftAmounts: async (companyNameContains?: string, grossAmountGt?: number, grossAmountLt?: number, dueDateGt?: string, dueDateLt?: string, numberRangeIdEq?: Array<string>, pageNumber?: number, pageSize?: number, sortAttribute?: string, sortDirection?: SortDirection, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Drafts/TotalAmounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (companyNameContains !== undefined) {
                localVarQueryParameter['CompanyName_Contains'] = companyNameContains;
            }

            if (grossAmountGt !== undefined) {
                localVarQueryParameter['GrossAmount_Gt'] = grossAmountGt;
            }

            if (grossAmountLt !== undefined) {
                localVarQueryParameter['GrossAmount_Lt'] = grossAmountLt;
            }

            if (dueDateGt !== undefined) {
                localVarQueryParameter['DueDate_Gt'] = (dueDateGt as any instanceof Date) ?
                    (dueDateGt as any).toISOString() :
                    dueDateGt;
            }

            if (dueDateLt !== undefined) {
                localVarQueryParameter['DueDate_Lt'] = (dueDateLt as any instanceof Date) ?
                    (dueDateLt as any).toISOString() :
                    dueDateLt;
            }

            if (numberRangeIdEq) {
                localVarQueryParameter['NumberRangeId_Eq'] = numberRangeIdEq;
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['PageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['PageSize'] = pageSize;
            }

            if (sortAttribute !== undefined) {
                localVarQueryParameter['SortAttribute'] = sortAttribute;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['SortDirection'] = sortDirection;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} draftId 
         * @param {RemoveCommentForDraftCommand} [removeCommentForDraftCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeCommentForDraft: async (draftId: string, removeCommentForDraftCommand?: RemoveCommentForDraftCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'draftId' is not null or undefined
            assertParamExists('removeCommentForDraft', 'draftId', draftId)
            const localVarPath = `/api/v1/Drafts/{draftId}/RemoveCommentForDraft`
                .replace('{draftId}', encodeURIComponent(String(draftId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(removeCommentForDraftCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeDraft: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('removeDraft', 'id', id)
            const localVarPath = `/api/v1/Drafts/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DraftsApi - functional programming interface
 */
export const DraftsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DraftsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} draftId 
         * @param {AddCommentForDraftCommand} [addCommentForDraftCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addCommentForDraft(draftId: string, addCommentForDraftCommand?: AddCommentForDraftCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addCommentForDraft(draftId, addCommentForDraftCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DraftsApi.addCommentForDraft']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {AddDraftCommand} [addDraftCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addDraft(addDraftCommand?: AddDraftCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DraftReadModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addDraft(addDraftCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DraftsApi.addDraft']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDraftById(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DraftReadModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDraftById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DraftsApi.getDraftById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [companyNameContains] 
         * @param {number} [grossAmountGt] 
         * @param {number} [grossAmountLt] 
         * @param {string} [dueDateGt] 
         * @param {string} [dueDateLt] 
         * @param {Array<string>} [numberRangeIdEq] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [sortAttribute] 
         * @param {SortDirection} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDrafts(companyNameContains?: string, grossAmountGt?: number, grossAmountLt?: number, dueDateGt?: string, dueDateLt?: string, numberRangeIdEq?: Array<string>, pageNumber?: number, pageSize?: number, sortAttribute?: string, sortDirection?: SortDirection, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DraftReadModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDrafts(companyNameContains, grossAmountGt, grossAmountLt, dueDateGt, dueDateLt, numberRangeIdEq, pageNumber, pageSize, sortAttribute, sortDirection, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DraftsApi.getDrafts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [companyNameContains] 
         * @param {number} [grossAmountGt] 
         * @param {number} [grossAmountLt] 
         * @param {string} [dueDateGt] 
         * @param {string} [dueDateLt] 
         * @param {Array<string>} [numberRangeIdEq] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [sortAttribute] 
         * @param {SortDirection} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTotalDraftAmounts(companyNameContains?: string, grossAmountGt?: number, grossAmountLt?: number, dueDateGt?: string, dueDateLt?: string, numberRangeIdEq?: Array<string>, pageNumber?: number, pageSize?: number, sortAttribute?: string, sortDirection?: SortDirection, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TotalInvoiceAmounts>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTotalDraftAmounts(companyNameContains, grossAmountGt, grossAmountLt, dueDateGt, dueDateLt, numberRangeIdEq, pageNumber, pageSize, sortAttribute, sortDirection, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DraftsApi.getTotalDraftAmounts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} draftId 
         * @param {RemoveCommentForDraftCommand} [removeCommentForDraftCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeCommentForDraft(draftId: string, removeCommentForDraftCommand?: RemoveCommentForDraftCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeCommentForDraft(draftId, removeCommentForDraftCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DraftsApi.removeCommentForDraft']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeDraft(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DraftReadModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeDraft(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DraftsApi.removeDraft']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DraftsApi - factory interface
 */
export const DraftsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DraftsApiFp(configuration)
    return {
        /**
         * 
         * @param {DraftsApiAddCommentForDraftRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCommentForDraft(requestParameters: DraftsApiAddCommentForDraftRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.addCommentForDraft(requestParameters.draftId, requestParameters.addCommentForDraftCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DraftsApiAddDraftRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDraft(requestParameters: DraftsApiAddDraftRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<DraftReadModel> {
            return localVarFp.addDraft(requestParameters.addDraftCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DraftsApiGetDraftByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDraftById(requestParameters: DraftsApiGetDraftByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<DraftReadModel> {
            return localVarFp.getDraftById(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DraftsApiGetDraftsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDrafts(requestParameters: DraftsApiGetDraftsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<DraftReadModel>> {
            return localVarFp.getDrafts(requestParameters.companyNameContains, requestParameters.grossAmountGt, requestParameters.grossAmountLt, requestParameters.dueDateGt, requestParameters.dueDateLt, requestParameters.numberRangeIdEq, requestParameters.pageNumber, requestParameters.pageSize, requestParameters.sortAttribute, requestParameters.sortDirection, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DraftsApiGetTotalDraftAmountsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTotalDraftAmounts(requestParameters: DraftsApiGetTotalDraftAmountsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<TotalInvoiceAmounts> {
            return localVarFp.getTotalDraftAmounts(requestParameters.companyNameContains, requestParameters.grossAmountGt, requestParameters.grossAmountLt, requestParameters.dueDateGt, requestParameters.dueDateLt, requestParameters.numberRangeIdEq, requestParameters.pageNumber, requestParameters.pageSize, requestParameters.sortAttribute, requestParameters.sortDirection, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DraftsApiRemoveCommentForDraftRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeCommentForDraft(requestParameters: DraftsApiRemoveCommentForDraftRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.removeCommentForDraft(requestParameters.draftId, requestParameters.removeCommentForDraftCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DraftsApiRemoveDraftRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeDraft(requestParameters: DraftsApiRemoveDraftRequest, options?: RawAxiosRequestConfig): AxiosPromise<DraftReadModel> {
            return localVarFp.removeDraft(requestParameters.id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for addCommentForDraft operation in DraftsApi.
 */
export interface DraftsApiAddCommentForDraftRequest {
    readonly draftId: string

    readonly addCommentForDraftCommand?: AddCommentForDraftCommand
}

/**
 * Request parameters for addDraft operation in DraftsApi.
 */
export interface DraftsApiAddDraftRequest {
    readonly addDraftCommand?: AddDraftCommand
}

/**
 * Request parameters for getDraftById operation in DraftsApi.
 */
export interface DraftsApiGetDraftByIdRequest {
    readonly id: string
}

/**
 * Request parameters for getDrafts operation in DraftsApi.
 */
export interface DraftsApiGetDraftsRequest {
    readonly companyNameContains?: string

    readonly grossAmountGt?: number

    readonly grossAmountLt?: number

    readonly dueDateGt?: string

    readonly dueDateLt?: string

    readonly numberRangeIdEq?: Array<string>

    readonly pageNumber?: number

    readonly pageSize?: number

    readonly sortAttribute?: string

    readonly sortDirection?: SortDirection
}

/**
 * Request parameters for getTotalDraftAmounts operation in DraftsApi.
 */
export interface DraftsApiGetTotalDraftAmountsRequest {
    readonly companyNameContains?: string

    readonly grossAmountGt?: number

    readonly grossAmountLt?: number

    readonly dueDateGt?: string

    readonly dueDateLt?: string

    readonly numberRangeIdEq?: Array<string>

    readonly pageNumber?: number

    readonly pageSize?: number

    readonly sortAttribute?: string

    readonly sortDirection?: SortDirection
}

/**
 * Request parameters for removeCommentForDraft operation in DraftsApi.
 */
export interface DraftsApiRemoveCommentForDraftRequest {
    readonly draftId: string

    readonly removeCommentForDraftCommand?: RemoveCommentForDraftCommand
}

/**
 * Request parameters for removeDraft operation in DraftsApi.
 */
export interface DraftsApiRemoveDraftRequest {
    readonly id: string
}

/**
 * DraftsApi - object-oriented interface
 */
export class DraftsApi extends BaseAPI {
    /**
     * 
     * @param {DraftsApiAddCommentForDraftRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addCommentForDraft(requestParameters: DraftsApiAddCommentForDraftRequest, options?: RawAxiosRequestConfig) {
        return DraftsApiFp(this.configuration).addCommentForDraft(requestParameters.draftId, requestParameters.addCommentForDraftCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DraftsApiAddDraftRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addDraft(requestParameters: DraftsApiAddDraftRequest = {}, options?: RawAxiosRequestConfig) {
        return DraftsApiFp(this.configuration).addDraft(requestParameters.addDraftCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DraftsApiGetDraftByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getDraftById(requestParameters: DraftsApiGetDraftByIdRequest, options?: RawAxiosRequestConfig) {
        return DraftsApiFp(this.configuration).getDraftById(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DraftsApiGetDraftsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getDrafts(requestParameters: DraftsApiGetDraftsRequest = {}, options?: RawAxiosRequestConfig) {
        return DraftsApiFp(this.configuration).getDrafts(requestParameters.companyNameContains, requestParameters.grossAmountGt, requestParameters.grossAmountLt, requestParameters.dueDateGt, requestParameters.dueDateLt, requestParameters.numberRangeIdEq, requestParameters.pageNumber, requestParameters.pageSize, requestParameters.sortAttribute, requestParameters.sortDirection, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DraftsApiGetTotalDraftAmountsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getTotalDraftAmounts(requestParameters: DraftsApiGetTotalDraftAmountsRequest = {}, options?: RawAxiosRequestConfig) {
        return DraftsApiFp(this.configuration).getTotalDraftAmounts(requestParameters.companyNameContains, requestParameters.grossAmountGt, requestParameters.grossAmountLt, requestParameters.dueDateGt, requestParameters.dueDateLt, requestParameters.numberRangeIdEq, requestParameters.pageNumber, requestParameters.pageSize, requestParameters.sortAttribute, requestParameters.sortDirection, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DraftsApiRemoveCommentForDraftRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public removeCommentForDraft(requestParameters: DraftsApiRemoveCommentForDraftRequest, options?: RawAxiosRequestConfig) {
        return DraftsApiFp(this.configuration).removeCommentForDraft(requestParameters.draftId, requestParameters.removeCommentForDraftCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DraftsApiRemoveDraftRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public removeDraft(requestParameters: DraftsApiRemoveDraftRequest, options?: RawAxiosRequestConfig) {
        return DraftsApiFp(this.configuration).removeDraft(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ExpenditureAccountsApi - axios parameter creator
 */
export const ExpenditureAccountsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [userId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExpenditureAccounts: async (userId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ExpenditureAccounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExpenditureAccountsApi - functional programming interface
 */
export const ExpenditureAccountsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ExpenditureAccountsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [userId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExpenditureAccounts(userId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ExpenditureAccountReadModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExpenditureAccounts(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExpenditureAccountsApi.getExpenditureAccounts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ExpenditureAccountsApi - factory interface
 */
export const ExpenditureAccountsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ExpenditureAccountsApiFp(configuration)
    return {
        /**
         * 
         * @param {ExpenditureAccountsApiGetExpenditureAccountsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExpenditureAccounts(requestParameters: ExpenditureAccountsApiGetExpenditureAccountsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<ExpenditureAccountReadModel>> {
            return localVarFp.getExpenditureAccounts(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getExpenditureAccounts operation in ExpenditureAccountsApi.
 */
export interface ExpenditureAccountsApiGetExpenditureAccountsRequest {
    readonly userId?: string
}

/**
 * ExpenditureAccountsApi - object-oriented interface
 */
export class ExpenditureAccountsApi extends BaseAPI {
    /**
     * 
     * @param {ExpenditureAccountsApiGetExpenditureAccountsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getExpenditureAccounts(requestParameters: ExpenditureAccountsApiGetExpenditureAccountsRequest = {}, options?: RawAxiosRequestConfig) {
        return ExpenditureAccountsApiFp(this.configuration).getExpenditureAccounts(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FilesApi - axios parameter creator
 */
export const FilesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFileById: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getFileById', 'id', id)
            const localVarPath = `/api/v1/Files/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FilesApi - functional programming interface
 */
export const FilesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FilesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFileById(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadedFileWithContent>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFileById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FilesApi.getFileById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FilesApi - factory interface
 */
export const FilesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FilesApiFp(configuration)
    return {
        /**
         * 
         * @param {FilesApiGetFileByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFileById(requestParameters: FilesApiGetFileByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<UploadedFileWithContent> {
            return localVarFp.getFileById(requestParameters.id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getFileById operation in FilesApi.
 */
export interface FilesApiGetFileByIdRequest {
    readonly id: string
}

/**
 * FilesApi - object-oriented interface
 */
export class FilesApi extends BaseAPI {
    /**
     * 
     * @param {FilesApiGetFileByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getFileById(requestParameters: FilesApiGetFileByIdRequest, options?: RawAxiosRequestConfig) {
        return FilesApiFp(this.configuration).getFileById(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * InvoiceRemindersApi - axios parameter creator
 */
export const InvoiceRemindersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} invoiceReminderId 
         * @param {AddCommentForInvoiceReminderCommand} [addCommentForInvoiceReminderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCommentForInvoiceReminder: async (invoiceReminderId: string, addCommentForInvoiceReminderCommand?: AddCommentForInvoiceReminderCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'invoiceReminderId' is not null or undefined
            assertParamExists('addCommentForInvoiceReminder', 'invoiceReminderId', invoiceReminderId)
            const localVarPath = `/api/v1/InvoiceReminders/{invoiceReminderId}/AddCommentForInvoiceReminder`
                .replace('{invoiceReminderId}', encodeURIComponent(String(invoiceReminderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addCommentForInvoiceReminderCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadInvoiceReminder: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('downloadInvoiceReminder', 'id', id)
            const localVarPath = `/api/v1/InvoiceReminders/{id}/Pdf`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/pdf,application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoiceReminderById: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getInvoiceReminderById', 'id', id)
            const localVarPath = `/api/v1/InvoiceReminders/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {object} [filter] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [sortAttribute] 
         * @param {SortDirection} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoiceReminders: async (filter?: object, pageNumber?: number, pageSize?: number, sortAttribute?: string, sortDirection?: SortDirection, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/InvoiceReminders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filter !== undefined) {
                for (const [key, value] of Object.entries(filter)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['PageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['PageSize'] = pageSize;
            }

            if (sortAttribute !== undefined) {
                localVarQueryParameter['SortAttribute'] = sortAttribute;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['SortDirection'] = sortDirection;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} invoiceId 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [sortAttribute] 
         * @param {SortDirection} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoiceRemindersByInvoiceId: async (invoiceId: string, pageNumber?: number, pageSize?: number, sortAttribute?: string, sortDirection?: SortDirection, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'invoiceId' is not null or undefined
            assertParamExists('getInvoiceRemindersByInvoiceId', 'invoiceId', invoiceId)
            const localVarPath = `/api/v1/InvoiceReminders/ByInvoice/{invoiceId}`
                .replace('{invoiceId}', encodeURIComponent(String(invoiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pageNumber !== undefined) {
                localVarQueryParameter['PageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['PageSize'] = pageSize;
            }

            if (sortAttribute !== undefined) {
                localVarQueryParameter['SortAttribute'] = sortAttribute;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['SortDirection'] = sortDirection;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} invoiceReminderId 
         * @param {RemoveCommentForInvoiceReminderCommand} [removeCommentForInvoiceReminderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeCommentForInvoiceReminder: async (invoiceReminderId: string, removeCommentForInvoiceReminderCommand?: RemoveCommentForInvoiceReminderCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'invoiceReminderId' is not null or undefined
            assertParamExists('removeCommentForInvoiceReminder', 'invoiceReminderId', invoiceReminderId)
            const localVarPath = `/api/v1/InvoiceReminders/{invoiceReminderId}/RemoveCommentForInvoiceReminder`
                .replace('{invoiceReminderId}', encodeURIComponent(String(invoiceReminderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(removeCommentForInvoiceReminderCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {SendInvoiceReminderByMailCommand} [sendInvoiceReminderByMailCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendInvoiceReminder: async (id: string, sendInvoiceReminderByMailCommand?: SendInvoiceReminderByMailCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('sendInvoiceReminder', 'id', id)
            const localVarPath = `/api/v1/InvoiceReminders/{id}/Send`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendInvoiceReminderByMailCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InvoiceRemindersApi - functional programming interface
 */
export const InvoiceRemindersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InvoiceRemindersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} invoiceReminderId 
         * @param {AddCommentForInvoiceReminderCommand} [addCommentForInvoiceReminderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addCommentForInvoiceReminder(invoiceReminderId: string, addCommentForInvoiceReminderCommand?: AddCommentForInvoiceReminderCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addCommentForInvoiceReminder(invoiceReminderId, addCommentForInvoiceReminderCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceRemindersApi.addCommentForInvoiceReminder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadInvoiceReminder(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadInvoiceReminder(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceRemindersApi.downloadInvoiceReminder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInvoiceReminderById(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoiceReminderReadModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInvoiceReminderById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceRemindersApi.getInvoiceReminderById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {object} [filter] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [sortAttribute] 
         * @param {SortDirection} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInvoiceReminders(filter?: object, pageNumber?: number, pageSize?: number, sortAttribute?: string, sortDirection?: SortDirection, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InvoiceReminderReadModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInvoiceReminders(filter, pageNumber, pageSize, sortAttribute, sortDirection, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceRemindersApi.getInvoiceReminders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} invoiceId 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [sortAttribute] 
         * @param {SortDirection} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInvoiceRemindersByInvoiceId(invoiceId: string, pageNumber?: number, pageSize?: number, sortAttribute?: string, sortDirection?: SortDirection, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InvoiceReminderReadModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInvoiceRemindersByInvoiceId(invoiceId, pageNumber, pageSize, sortAttribute, sortDirection, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceRemindersApi.getInvoiceRemindersByInvoiceId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} invoiceReminderId 
         * @param {RemoveCommentForInvoiceReminderCommand} [removeCommentForInvoiceReminderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeCommentForInvoiceReminder(invoiceReminderId: string, removeCommentForInvoiceReminderCommand?: RemoveCommentForInvoiceReminderCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeCommentForInvoiceReminder(invoiceReminderId, removeCommentForInvoiceReminderCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceRemindersApi.removeCommentForInvoiceReminder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {SendInvoiceReminderByMailCommand} [sendInvoiceReminderByMailCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendInvoiceReminder(id: string, sendInvoiceReminderByMailCommand?: SendInvoiceReminderByMailCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendInvoiceReminder(id, sendInvoiceReminderByMailCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceRemindersApi.sendInvoiceReminder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InvoiceRemindersApi - factory interface
 */
export const InvoiceRemindersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InvoiceRemindersApiFp(configuration)
    return {
        /**
         * 
         * @param {InvoiceRemindersApiAddCommentForInvoiceReminderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCommentForInvoiceReminder(requestParameters: InvoiceRemindersApiAddCommentForInvoiceReminderRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.addCommentForInvoiceReminder(requestParameters.invoiceReminderId, requestParameters.addCommentForInvoiceReminderCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InvoiceRemindersApiDownloadInvoiceReminderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadInvoiceReminder(requestParameters: InvoiceRemindersApiDownloadInvoiceReminderRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.downloadInvoiceReminder(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InvoiceRemindersApiGetInvoiceReminderByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoiceReminderById(requestParameters: InvoiceRemindersApiGetInvoiceReminderByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<InvoiceReminderReadModel> {
            return localVarFp.getInvoiceReminderById(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InvoiceRemindersApiGetInvoiceRemindersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoiceReminders(requestParameters: InvoiceRemindersApiGetInvoiceRemindersRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<InvoiceReminderReadModel>> {
            return localVarFp.getInvoiceReminders(requestParameters.filter, requestParameters.pageNumber, requestParameters.pageSize, requestParameters.sortAttribute, requestParameters.sortDirection, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InvoiceRemindersApiGetInvoiceRemindersByInvoiceIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoiceRemindersByInvoiceId(requestParameters: InvoiceRemindersApiGetInvoiceRemindersByInvoiceIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<InvoiceReminderReadModel>> {
            return localVarFp.getInvoiceRemindersByInvoiceId(requestParameters.invoiceId, requestParameters.pageNumber, requestParameters.pageSize, requestParameters.sortAttribute, requestParameters.sortDirection, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InvoiceRemindersApiRemoveCommentForInvoiceReminderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeCommentForInvoiceReminder(requestParameters: InvoiceRemindersApiRemoveCommentForInvoiceReminderRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.removeCommentForInvoiceReminder(requestParameters.invoiceReminderId, requestParameters.removeCommentForInvoiceReminderCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InvoiceRemindersApiSendInvoiceReminderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendInvoiceReminder(requestParameters: InvoiceRemindersApiSendInvoiceReminderRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.sendInvoiceReminder(requestParameters.id, requestParameters.sendInvoiceReminderByMailCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for addCommentForInvoiceReminder operation in InvoiceRemindersApi.
 */
export interface InvoiceRemindersApiAddCommentForInvoiceReminderRequest {
    readonly invoiceReminderId: string

    readonly addCommentForInvoiceReminderCommand?: AddCommentForInvoiceReminderCommand
}

/**
 * Request parameters for downloadInvoiceReminder operation in InvoiceRemindersApi.
 */
export interface InvoiceRemindersApiDownloadInvoiceReminderRequest {
    readonly id: string
}

/**
 * Request parameters for getInvoiceReminderById operation in InvoiceRemindersApi.
 */
export interface InvoiceRemindersApiGetInvoiceReminderByIdRequest {
    readonly id: string
}

/**
 * Request parameters for getInvoiceReminders operation in InvoiceRemindersApi.
 */
export interface InvoiceRemindersApiGetInvoiceRemindersRequest {
    readonly filter?: object

    readonly pageNumber?: number

    readonly pageSize?: number

    readonly sortAttribute?: string

    readonly sortDirection?: SortDirection
}

/**
 * Request parameters for getInvoiceRemindersByInvoiceId operation in InvoiceRemindersApi.
 */
export interface InvoiceRemindersApiGetInvoiceRemindersByInvoiceIdRequest {
    readonly invoiceId: string

    readonly pageNumber?: number

    readonly pageSize?: number

    readonly sortAttribute?: string

    readonly sortDirection?: SortDirection
}

/**
 * Request parameters for removeCommentForInvoiceReminder operation in InvoiceRemindersApi.
 */
export interface InvoiceRemindersApiRemoveCommentForInvoiceReminderRequest {
    readonly invoiceReminderId: string

    readonly removeCommentForInvoiceReminderCommand?: RemoveCommentForInvoiceReminderCommand
}

/**
 * Request parameters for sendInvoiceReminder operation in InvoiceRemindersApi.
 */
export interface InvoiceRemindersApiSendInvoiceReminderRequest {
    readonly id: string

    readonly sendInvoiceReminderByMailCommand?: SendInvoiceReminderByMailCommand
}

/**
 * InvoiceRemindersApi - object-oriented interface
 */
export class InvoiceRemindersApi extends BaseAPI {
    /**
     * 
     * @param {InvoiceRemindersApiAddCommentForInvoiceReminderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addCommentForInvoiceReminder(requestParameters: InvoiceRemindersApiAddCommentForInvoiceReminderRequest, options?: RawAxiosRequestConfig) {
        return InvoiceRemindersApiFp(this.configuration).addCommentForInvoiceReminder(requestParameters.invoiceReminderId, requestParameters.addCommentForInvoiceReminderCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InvoiceRemindersApiDownloadInvoiceReminderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public downloadInvoiceReminder(requestParameters: InvoiceRemindersApiDownloadInvoiceReminderRequest, options?: RawAxiosRequestConfig) {
        return InvoiceRemindersApiFp(this.configuration).downloadInvoiceReminder(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InvoiceRemindersApiGetInvoiceReminderByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getInvoiceReminderById(requestParameters: InvoiceRemindersApiGetInvoiceReminderByIdRequest, options?: RawAxiosRequestConfig) {
        return InvoiceRemindersApiFp(this.configuration).getInvoiceReminderById(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InvoiceRemindersApiGetInvoiceRemindersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getInvoiceReminders(requestParameters: InvoiceRemindersApiGetInvoiceRemindersRequest = {}, options?: RawAxiosRequestConfig) {
        return InvoiceRemindersApiFp(this.configuration).getInvoiceReminders(requestParameters.filter, requestParameters.pageNumber, requestParameters.pageSize, requestParameters.sortAttribute, requestParameters.sortDirection, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InvoiceRemindersApiGetInvoiceRemindersByInvoiceIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getInvoiceRemindersByInvoiceId(requestParameters: InvoiceRemindersApiGetInvoiceRemindersByInvoiceIdRequest, options?: RawAxiosRequestConfig) {
        return InvoiceRemindersApiFp(this.configuration).getInvoiceRemindersByInvoiceId(requestParameters.invoiceId, requestParameters.pageNumber, requestParameters.pageSize, requestParameters.sortAttribute, requestParameters.sortDirection, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InvoiceRemindersApiRemoveCommentForInvoiceReminderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public removeCommentForInvoiceReminder(requestParameters: InvoiceRemindersApiRemoveCommentForInvoiceReminderRequest, options?: RawAxiosRequestConfig) {
        return InvoiceRemindersApiFp(this.configuration).removeCommentForInvoiceReminder(requestParameters.invoiceReminderId, requestParameters.removeCommentForInvoiceReminderCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InvoiceRemindersApiSendInvoiceReminderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public sendInvoiceReminder(requestParameters: InvoiceRemindersApiSendInvoiceReminderRequest, options?: RawAxiosRequestConfig) {
        return InvoiceRemindersApiFp(this.configuration).sendInvoiceReminder(requestParameters.id, requestParameters.sendInvoiceReminderByMailCommand, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * InvoicesApi - axios parameter creator
 */
export const InvoicesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} invoiceId 
         * @param {AddCommentForInvoiceCommand} [addCommentForInvoiceCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCommentForInvoice: async (invoiceId: string, addCommentForInvoiceCommand?: AddCommentForInvoiceCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'invoiceId' is not null or undefined
            assertParamExists('addCommentForInvoice', 'invoiceId', invoiceId)
            const localVarPath = `/api/v1/Invoices/{invoiceId}/AddCommentForInvoice`
                .replace('{invoiceId}', encodeURIComponent(String(invoiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addCommentForInvoiceCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {BookInvoiceCommand} [bookInvoiceCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookInvoice: async (id: string, bookInvoiceCommand?: BookInvoiceCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('bookInvoice', 'id', id)
            const localVarPath = `/api/v1/Invoices/{id}/BookInvoice`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bookInvoiceCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {CancelInvoiceCommand} [cancelInvoiceCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelInvoice: async (id: string, cancelInvoiceCommand?: CancelInvoiceCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('cancelInvoice', 'id', id)
            const localVarPath = `/api/v1/Invoices/{id}/CancelInvoice`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cancelInvoiceCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateInvoiceCommand} [createInvoiceCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInvoice: async (createInvoiceCommand?: CreateInvoiceCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Invoices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createInvoiceCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateAndSendInvoiceCommand} [createAndSendInvoiceCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInvoiceAndSend: async (createAndSendInvoiceCommand?: CreateAndSendInvoiceCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Invoices/CreateAndSend`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAndSendInvoiceCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateInvoicePreviewCommand} [createInvoicePreviewCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInvoicePreview: async (createInvoicePreviewCommand?: CreateInvoicePreviewCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Invoices/Preview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createInvoicePreviewCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {CreateInvoiceReminderCommand} [createInvoiceReminderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInvoiceReminder: async (id: string, createInvoiceReminderCommand?: CreateInvoiceReminderCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createInvoiceReminder', 'id', id)
            const localVarPath = `/api/v1/Invoices/{id}/CreateInvoiceReminder`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createInvoiceReminderCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {CreateReverseInvoicePreviewCommand} [createReverseInvoicePreviewCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createReverseInvoicePreview: async (id: string, createReverseInvoicePreviewCommand?: CreateReverseInvoicePreviewCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createReverseInvoicePreview', 'id', id)
            const localVarPath = `/api/v1/Invoices/{id}/Reverse/Preview`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createReverseInvoicePreviewCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadPdf: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('downloadPdf', 'id', id)
            const localVarPath = `/api/v1/Invoices/{id}/Pdf`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/pdf,application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoiceById: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getInvoiceById', 'id', id)
            const localVarPath = `/api/v1/Invoices/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [invoiceDateYearAsIntEq] 
         * @param {number} [invoiceDateMonthAsIntEq] 
         * @param {string} [canceledInvoiceIdEqNull] 
         * @param {boolean} [bookingInfosEqNull] 
         * @param {boolean} [isCanceledEq] 
         * @param {boolean} [isSendByMail] 
         * @param {number} [grossAmountGt] 
         * @param {number} [grossAmountLt] 
         * @param {string} [invoiceDateGt] 
         * @param {string} [invoiceDateLt] 
         * @param {string} [dueDateGt] 
         * @param {string} [dueDateLt] 
         * @param {Array<InvoiceState>} [invoiceStateEq] 
         * @param {string} [invoiceNumberContains] 
         * @param {Array<string>} [numberRangeIdEq] 
         * @param {string} [companyNameContains] 
         * @param {string} [invoiceRecipientIdEq] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [sortAttribute] 
         * @param {SortDirection} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoices: async (invoiceDateYearAsIntEq?: number, invoiceDateMonthAsIntEq?: number, canceledInvoiceIdEqNull?: string, bookingInfosEqNull?: boolean, isCanceledEq?: boolean, isSendByMail?: boolean, grossAmountGt?: number, grossAmountLt?: number, invoiceDateGt?: string, invoiceDateLt?: string, dueDateGt?: string, dueDateLt?: string, invoiceStateEq?: Array<InvoiceState>, invoiceNumberContains?: string, numberRangeIdEq?: Array<string>, companyNameContains?: string, invoiceRecipientIdEq?: string, pageNumber?: number, pageSize?: number, sortAttribute?: string, sortDirection?: SortDirection, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Invoices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (invoiceDateYearAsIntEq !== undefined) {
                localVarQueryParameter['InvoiceDate_YearAsInt_Eq'] = invoiceDateYearAsIntEq;
            }

            if (invoiceDateMonthAsIntEq !== undefined) {
                localVarQueryParameter['InvoiceDate_MonthAsInt_Eq'] = invoiceDateMonthAsIntEq;
            }

            if (canceledInvoiceIdEqNull !== undefined) {
                localVarQueryParameter['CanceledInvoiceId_EqNull'] = canceledInvoiceIdEqNull;
            }

            if (bookingInfosEqNull !== undefined) {
                localVarQueryParameter['BookingInfos_EqNull'] = bookingInfosEqNull;
            }

            if (isCanceledEq !== undefined) {
                localVarQueryParameter['IsCanceled_Eq'] = isCanceledEq;
            }

            if (isSendByMail !== undefined) {
                localVarQueryParameter['IsSendByMail'] = isSendByMail;
            }

            if (grossAmountGt !== undefined) {
                localVarQueryParameter['GrossAmount_Gt'] = grossAmountGt;
            }

            if (grossAmountLt !== undefined) {
                localVarQueryParameter['GrossAmount_Lt'] = grossAmountLt;
            }

            if (invoiceDateGt !== undefined) {
                localVarQueryParameter['InvoiceDate_Gt'] = (invoiceDateGt as any instanceof Date) ?
                    (invoiceDateGt as any).toISOString() :
                    invoiceDateGt;
            }

            if (invoiceDateLt !== undefined) {
                localVarQueryParameter['InvoiceDate_Lt'] = (invoiceDateLt as any instanceof Date) ?
                    (invoiceDateLt as any).toISOString() :
                    invoiceDateLt;
            }

            if (dueDateGt !== undefined) {
                localVarQueryParameter['DueDate_Gt'] = (dueDateGt as any instanceof Date) ?
                    (dueDateGt as any).toISOString() :
                    dueDateGt;
            }

            if (dueDateLt !== undefined) {
                localVarQueryParameter['DueDate_Lt'] = (dueDateLt as any instanceof Date) ?
                    (dueDateLt as any).toISOString() :
                    dueDateLt;
            }

            if (invoiceStateEq) {
                localVarQueryParameter['InvoiceState_Eq'] = invoiceStateEq;
            }

            if (invoiceNumberContains !== undefined) {
                localVarQueryParameter['InvoiceNumber_Contains'] = invoiceNumberContains;
            }

            if (numberRangeIdEq) {
                localVarQueryParameter['NumberRangeId_Eq'] = numberRangeIdEq;
            }

            if (companyNameContains !== undefined) {
                localVarQueryParameter['CompanyName_Contains'] = companyNameContains;
            }

            if (invoiceRecipientIdEq !== undefined) {
                localVarQueryParameter['InvoiceRecipientId_Eq'] = invoiceRecipientIdEq;
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['PageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['PageSize'] = pageSize;
            }

            if (sortAttribute !== undefined) {
                localVarQueryParameter['SortAttribute'] = sortAttribute;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['SortDirection'] = sortDirection;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [invoiceDateYearAsIntEq] 
         * @param {number} [invoiceDateMonthAsIntEq] 
         * @param {string} [canceledInvoiceIdEqNull] 
         * @param {boolean} [bookingInfosEqNull] 
         * @param {boolean} [isCanceledEq] 
         * @param {boolean} [isSendByMail] 
         * @param {number} [grossAmountGt] 
         * @param {number} [grossAmountLt] 
         * @param {string} [invoiceDateGt] 
         * @param {string} [invoiceDateLt] 
         * @param {string} [dueDateGt] 
         * @param {string} [dueDateLt] 
         * @param {Array<InvoiceState>} [invoiceStateEq] 
         * @param {string} [invoiceNumberContains] 
         * @param {Array<string>} [numberRangeIdEq] 
         * @param {string} [companyNameContains] 
         * @param {string} [invoiceRecipientIdEq] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [sortAttribute] 
         * @param {SortDirection} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTotalInvoiceAmounts: async (invoiceDateYearAsIntEq?: number, invoiceDateMonthAsIntEq?: number, canceledInvoiceIdEqNull?: string, bookingInfosEqNull?: boolean, isCanceledEq?: boolean, isSendByMail?: boolean, grossAmountGt?: number, grossAmountLt?: number, invoiceDateGt?: string, invoiceDateLt?: string, dueDateGt?: string, dueDateLt?: string, invoiceStateEq?: Array<InvoiceState>, invoiceNumberContains?: string, numberRangeIdEq?: Array<string>, companyNameContains?: string, invoiceRecipientIdEq?: string, pageNumber?: number, pageSize?: number, sortAttribute?: string, sortDirection?: SortDirection, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Invoices/TotalAmounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (invoiceDateYearAsIntEq !== undefined) {
                localVarQueryParameter['InvoiceDate_YearAsInt_Eq'] = invoiceDateYearAsIntEq;
            }

            if (invoiceDateMonthAsIntEq !== undefined) {
                localVarQueryParameter['InvoiceDate_MonthAsInt_Eq'] = invoiceDateMonthAsIntEq;
            }

            if (canceledInvoiceIdEqNull !== undefined) {
                localVarQueryParameter['CanceledInvoiceId_EqNull'] = canceledInvoiceIdEqNull;
            }

            if (bookingInfosEqNull !== undefined) {
                localVarQueryParameter['BookingInfos_EqNull'] = bookingInfosEqNull;
            }

            if (isCanceledEq !== undefined) {
                localVarQueryParameter['IsCanceled_Eq'] = isCanceledEq;
            }

            if (isSendByMail !== undefined) {
                localVarQueryParameter['IsSendByMail'] = isSendByMail;
            }

            if (grossAmountGt !== undefined) {
                localVarQueryParameter['GrossAmount_Gt'] = grossAmountGt;
            }

            if (grossAmountLt !== undefined) {
                localVarQueryParameter['GrossAmount_Lt'] = grossAmountLt;
            }

            if (invoiceDateGt !== undefined) {
                localVarQueryParameter['InvoiceDate_Gt'] = (invoiceDateGt as any instanceof Date) ?
                    (invoiceDateGt as any).toISOString() :
                    invoiceDateGt;
            }

            if (invoiceDateLt !== undefined) {
                localVarQueryParameter['InvoiceDate_Lt'] = (invoiceDateLt as any instanceof Date) ?
                    (invoiceDateLt as any).toISOString() :
                    invoiceDateLt;
            }

            if (dueDateGt !== undefined) {
                localVarQueryParameter['DueDate_Gt'] = (dueDateGt as any instanceof Date) ?
                    (dueDateGt as any).toISOString() :
                    dueDateGt;
            }

            if (dueDateLt !== undefined) {
                localVarQueryParameter['DueDate_Lt'] = (dueDateLt as any instanceof Date) ?
                    (dueDateLt as any).toISOString() :
                    dueDateLt;
            }

            if (invoiceStateEq) {
                localVarQueryParameter['InvoiceState_Eq'] = invoiceStateEq;
            }

            if (invoiceNumberContains !== undefined) {
                localVarQueryParameter['InvoiceNumber_Contains'] = invoiceNumberContains;
            }

            if (numberRangeIdEq) {
                localVarQueryParameter['NumberRangeId_Eq'] = numberRangeIdEq;
            }

            if (companyNameContains !== undefined) {
                localVarQueryParameter['CompanyName_Contains'] = companyNameContains;
            }

            if (invoiceRecipientIdEq !== undefined) {
                localVarQueryParameter['InvoiceRecipientId_Eq'] = invoiceRecipientIdEq;
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['PageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['PageSize'] = pageSize;
            }

            if (sortAttribute !== undefined) {
                localVarQueryParameter['SortAttribute'] = sortAttribute;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['SortDirection'] = sortDirection;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [invoiceDateYearAsIntEq] 
         * @param {number} [invoiceDateMonthAsIntEq] 
         * @param {string} [canceledInvoiceIdEqNull] 
         * @param {boolean} [bookingInfosEqNull] 
         * @param {boolean} [isCanceledEq] 
         * @param {boolean} [isSendByMail] 
         * @param {number} [grossAmountGt] 
         * @param {number} [grossAmountLt] 
         * @param {string} [invoiceDateGt] 
         * @param {string} [invoiceDateLt] 
         * @param {string} [dueDateGt] 
         * @param {string} [dueDateLt] 
         * @param {Array<InvoiceState>} [invoiceStateEq] 
         * @param {string} [invoiceNumberContains] 
         * @param {Array<string>} [numberRangeIdEq] 
         * @param {string} [companyNameContains] 
         * @param {string} [invoiceRecipientIdEq] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [sortAttribute] 
         * @param {SortDirection} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTotalInvoiceAmountsMonthly: async (invoiceDateYearAsIntEq?: number, invoiceDateMonthAsIntEq?: number, canceledInvoiceIdEqNull?: string, bookingInfosEqNull?: boolean, isCanceledEq?: boolean, isSendByMail?: boolean, grossAmountGt?: number, grossAmountLt?: number, invoiceDateGt?: string, invoiceDateLt?: string, dueDateGt?: string, dueDateLt?: string, invoiceStateEq?: Array<InvoiceState>, invoiceNumberContains?: string, numberRangeIdEq?: Array<string>, companyNameContains?: string, invoiceRecipientIdEq?: string, pageNumber?: number, pageSize?: number, sortAttribute?: string, sortDirection?: SortDirection, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Invoices/TotalAmounts/Monthly`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (invoiceDateYearAsIntEq !== undefined) {
                localVarQueryParameter['InvoiceDate_YearAsInt_Eq'] = invoiceDateYearAsIntEq;
            }

            if (invoiceDateMonthAsIntEq !== undefined) {
                localVarQueryParameter['InvoiceDate_MonthAsInt_Eq'] = invoiceDateMonthAsIntEq;
            }

            if (canceledInvoiceIdEqNull !== undefined) {
                localVarQueryParameter['CanceledInvoiceId_EqNull'] = canceledInvoiceIdEqNull;
            }

            if (bookingInfosEqNull !== undefined) {
                localVarQueryParameter['BookingInfos_EqNull'] = bookingInfosEqNull;
            }

            if (isCanceledEq !== undefined) {
                localVarQueryParameter['IsCanceled_Eq'] = isCanceledEq;
            }

            if (isSendByMail !== undefined) {
                localVarQueryParameter['IsSendByMail'] = isSendByMail;
            }

            if (grossAmountGt !== undefined) {
                localVarQueryParameter['GrossAmount_Gt'] = grossAmountGt;
            }

            if (grossAmountLt !== undefined) {
                localVarQueryParameter['GrossAmount_Lt'] = grossAmountLt;
            }

            if (invoiceDateGt !== undefined) {
                localVarQueryParameter['InvoiceDate_Gt'] = (invoiceDateGt as any instanceof Date) ?
                    (invoiceDateGt as any).toISOString() :
                    invoiceDateGt;
            }

            if (invoiceDateLt !== undefined) {
                localVarQueryParameter['InvoiceDate_Lt'] = (invoiceDateLt as any instanceof Date) ?
                    (invoiceDateLt as any).toISOString() :
                    invoiceDateLt;
            }

            if (dueDateGt !== undefined) {
                localVarQueryParameter['DueDate_Gt'] = (dueDateGt as any instanceof Date) ?
                    (dueDateGt as any).toISOString() :
                    dueDateGt;
            }

            if (dueDateLt !== undefined) {
                localVarQueryParameter['DueDate_Lt'] = (dueDateLt as any instanceof Date) ?
                    (dueDateLt as any).toISOString() :
                    dueDateLt;
            }

            if (invoiceStateEq) {
                localVarQueryParameter['InvoiceState_Eq'] = invoiceStateEq;
            }

            if (invoiceNumberContains !== undefined) {
                localVarQueryParameter['InvoiceNumber_Contains'] = invoiceNumberContains;
            }

            if (numberRangeIdEq) {
                localVarQueryParameter['NumberRangeId_Eq'] = numberRangeIdEq;
            }

            if (companyNameContains !== undefined) {
                localVarQueryParameter['CompanyName_Contains'] = companyNameContains;
            }

            if (invoiceRecipientIdEq !== undefined) {
                localVarQueryParameter['InvoiceRecipientId_Eq'] = invoiceRecipientIdEq;
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['PageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['PageSize'] = pageSize;
            }

            if (sortAttribute !== undefined) {
                localVarQueryParameter['SortAttribute'] = sortAttribute;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['SortDirection'] = sortDirection;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [userId] 
         * @param {number} [month] 
         * @param {number} [year] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTotalInvoiceCountForMontAndYear: async (userId?: string, month?: number, year?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Invoices/GetTotalInvoiceCountForMonthAndYear`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }

            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {MarkInvoiceAsPaidCommand} [markInvoiceAsPaidCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markInvoiceAsPaid: async (id: string, markInvoiceAsPaidCommand?: MarkInvoiceAsPaidCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('markInvoiceAsPaid', 'id', id)
            const localVarPath = `/api/v1/Invoices/{id}/MarkInvoiceAsPaid`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(markInvoiceAsPaidCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {MarkInvoiceAsPastDueCommand} [markInvoiceAsPastDueCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markInvoiceAsPastDue: async (id: string, markInvoiceAsPastDueCommand?: MarkInvoiceAsPastDueCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('markInvoiceAsPastDue', 'id', id)
            const localVarPath = `/api/v1/Invoices/{id}/MarkInvoiceAsPastDue`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(markInvoiceAsPastDueCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {MarkInvoiceAsPendingCommand} [markInvoiceAsPendingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markInvoiceAsPending: async (id: string, markInvoiceAsPendingCommand?: MarkInvoiceAsPendingCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('markInvoiceAsPending', 'id', id)
            const localVarPath = `/api/v1/Invoices/{id}/MarkInvoiceAsPending`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(markInvoiceAsPendingCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} invoiceId 
         * @param {RemoveCommentForInvoiceCommand} [removeCommentForInvoiceCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeCommentForInvoice: async (invoiceId: string, removeCommentForInvoiceCommand?: RemoveCommentForInvoiceCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'invoiceId' is not null or undefined
            assertParamExists('removeCommentForInvoice', 'invoiceId', invoiceId)
            const localVarPath = `/api/v1/Invoices/{invoiceId}/RemoveCommentForInvoice`
                .replace('{invoiceId}', encodeURIComponent(String(invoiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(removeCommentForInvoiceCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {SendInvoiceByMailCommand} [sendInvoiceByMailCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        send: async (id: string, sendInvoiceByMailCommand?: SendInvoiceByMailCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('send', 'id', id)
            const localVarPath = `/api/v1/Invoices/{id}/Send`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendInvoiceByMailCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InvoicesApi - functional programming interface
 */
export const InvoicesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InvoicesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} invoiceId 
         * @param {AddCommentForInvoiceCommand} [addCommentForInvoiceCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addCommentForInvoice(invoiceId: string, addCommentForInvoiceCommand?: AddCommentForInvoiceCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addCommentForInvoice(invoiceId, addCommentForInvoiceCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoicesApi.addCommentForInvoice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {BookInvoiceCommand} [bookInvoiceCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bookInvoice(id: string, bookInvoiceCommand?: BookInvoiceCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bookInvoice(id, bookInvoiceCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoicesApi.bookInvoice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {CancelInvoiceCommand} [cancelInvoiceCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelInvoice(id: string, cancelInvoiceCommand?: CancelInvoiceCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoiceReadModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelInvoice(id, cancelInvoiceCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoicesApi.cancelInvoice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateInvoiceCommand} [createInvoiceCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createInvoice(createInvoiceCommand?: CreateInvoiceCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AbstractReadModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createInvoice(createInvoiceCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoicesApi.createInvoice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateAndSendInvoiceCommand} [createAndSendInvoiceCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createInvoiceAndSend(createAndSendInvoiceCommand?: CreateAndSendInvoiceCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createInvoiceAndSend(createAndSendInvoiceCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoicesApi.createInvoiceAndSend']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateInvoicePreviewCommand} [createInvoicePreviewCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createInvoicePreview(createInvoicePreviewCommand?: CreateInvoicePreviewCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoiceReadModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createInvoicePreview(createInvoicePreviewCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoicesApi.createInvoicePreview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {CreateInvoiceReminderCommand} [createInvoiceReminderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createInvoiceReminder(id: string, createInvoiceReminderCommand?: CreateInvoiceReminderCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createInvoiceReminder(id, createInvoiceReminderCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoicesApi.createInvoiceReminder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {CreateReverseInvoicePreviewCommand} [createReverseInvoicePreviewCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createReverseInvoicePreview(id: string, createReverseInvoicePreviewCommand?: CreateReverseInvoicePreviewCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoiceReadModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createReverseInvoicePreview(id, createReverseInvoicePreviewCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoicesApi.createReverseInvoicePreview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadPdf(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadPdf(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoicesApi.downloadPdf']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInvoiceById(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoiceReadModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInvoiceById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoicesApi.getInvoiceById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [invoiceDateYearAsIntEq] 
         * @param {number} [invoiceDateMonthAsIntEq] 
         * @param {string} [canceledInvoiceIdEqNull] 
         * @param {boolean} [bookingInfosEqNull] 
         * @param {boolean} [isCanceledEq] 
         * @param {boolean} [isSendByMail] 
         * @param {number} [grossAmountGt] 
         * @param {number} [grossAmountLt] 
         * @param {string} [invoiceDateGt] 
         * @param {string} [invoiceDateLt] 
         * @param {string} [dueDateGt] 
         * @param {string} [dueDateLt] 
         * @param {Array<InvoiceState>} [invoiceStateEq] 
         * @param {string} [invoiceNumberContains] 
         * @param {Array<string>} [numberRangeIdEq] 
         * @param {string} [companyNameContains] 
         * @param {string} [invoiceRecipientIdEq] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [sortAttribute] 
         * @param {SortDirection} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInvoices(invoiceDateYearAsIntEq?: number, invoiceDateMonthAsIntEq?: number, canceledInvoiceIdEqNull?: string, bookingInfosEqNull?: boolean, isCanceledEq?: boolean, isSendByMail?: boolean, grossAmountGt?: number, grossAmountLt?: number, invoiceDateGt?: string, invoiceDateLt?: string, dueDateGt?: string, dueDateLt?: string, invoiceStateEq?: Array<InvoiceState>, invoiceNumberContains?: string, numberRangeIdEq?: Array<string>, companyNameContains?: string, invoiceRecipientIdEq?: string, pageNumber?: number, pageSize?: number, sortAttribute?: string, sortDirection?: SortDirection, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InvoiceReadModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInvoices(invoiceDateYearAsIntEq, invoiceDateMonthAsIntEq, canceledInvoiceIdEqNull, bookingInfosEqNull, isCanceledEq, isSendByMail, grossAmountGt, grossAmountLt, invoiceDateGt, invoiceDateLt, dueDateGt, dueDateLt, invoiceStateEq, invoiceNumberContains, numberRangeIdEq, companyNameContains, invoiceRecipientIdEq, pageNumber, pageSize, sortAttribute, sortDirection, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoicesApi.getInvoices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [invoiceDateYearAsIntEq] 
         * @param {number} [invoiceDateMonthAsIntEq] 
         * @param {string} [canceledInvoiceIdEqNull] 
         * @param {boolean} [bookingInfosEqNull] 
         * @param {boolean} [isCanceledEq] 
         * @param {boolean} [isSendByMail] 
         * @param {number} [grossAmountGt] 
         * @param {number} [grossAmountLt] 
         * @param {string} [invoiceDateGt] 
         * @param {string} [invoiceDateLt] 
         * @param {string} [dueDateGt] 
         * @param {string} [dueDateLt] 
         * @param {Array<InvoiceState>} [invoiceStateEq] 
         * @param {string} [invoiceNumberContains] 
         * @param {Array<string>} [numberRangeIdEq] 
         * @param {string} [companyNameContains] 
         * @param {string} [invoiceRecipientIdEq] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [sortAttribute] 
         * @param {SortDirection} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTotalInvoiceAmounts(invoiceDateYearAsIntEq?: number, invoiceDateMonthAsIntEq?: number, canceledInvoiceIdEqNull?: string, bookingInfosEqNull?: boolean, isCanceledEq?: boolean, isSendByMail?: boolean, grossAmountGt?: number, grossAmountLt?: number, invoiceDateGt?: string, invoiceDateLt?: string, dueDateGt?: string, dueDateLt?: string, invoiceStateEq?: Array<InvoiceState>, invoiceNumberContains?: string, numberRangeIdEq?: Array<string>, companyNameContains?: string, invoiceRecipientIdEq?: string, pageNumber?: number, pageSize?: number, sortAttribute?: string, sortDirection?: SortDirection, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TotalInvoiceAmounts>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTotalInvoiceAmounts(invoiceDateYearAsIntEq, invoiceDateMonthAsIntEq, canceledInvoiceIdEqNull, bookingInfosEqNull, isCanceledEq, isSendByMail, grossAmountGt, grossAmountLt, invoiceDateGt, invoiceDateLt, dueDateGt, dueDateLt, invoiceStateEq, invoiceNumberContains, numberRangeIdEq, companyNameContains, invoiceRecipientIdEq, pageNumber, pageSize, sortAttribute, sortDirection, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoicesApi.getTotalInvoiceAmounts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [invoiceDateYearAsIntEq] 
         * @param {number} [invoiceDateMonthAsIntEq] 
         * @param {string} [canceledInvoiceIdEqNull] 
         * @param {boolean} [bookingInfosEqNull] 
         * @param {boolean} [isCanceledEq] 
         * @param {boolean} [isSendByMail] 
         * @param {number} [grossAmountGt] 
         * @param {number} [grossAmountLt] 
         * @param {string} [invoiceDateGt] 
         * @param {string} [invoiceDateLt] 
         * @param {string} [dueDateGt] 
         * @param {string} [dueDateLt] 
         * @param {Array<InvoiceState>} [invoiceStateEq] 
         * @param {string} [invoiceNumberContains] 
         * @param {Array<string>} [numberRangeIdEq] 
         * @param {string} [companyNameContains] 
         * @param {string} [invoiceRecipientIdEq] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [sortAttribute] 
         * @param {SortDirection} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTotalInvoiceAmountsMonthly(invoiceDateYearAsIntEq?: number, invoiceDateMonthAsIntEq?: number, canceledInvoiceIdEqNull?: string, bookingInfosEqNull?: boolean, isCanceledEq?: boolean, isSendByMail?: boolean, grossAmountGt?: number, grossAmountLt?: number, invoiceDateGt?: string, invoiceDateLt?: string, dueDateGt?: string, dueDateLt?: string, invoiceStateEq?: Array<InvoiceState>, invoiceNumberContains?: string, numberRangeIdEq?: Array<string>, companyNameContains?: string, invoiceRecipientIdEq?: string, pageNumber?: number, pageSize?: number, sortAttribute?: string, sortDirection?: SortDirection, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TotalInvoiceAmounts>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTotalInvoiceAmountsMonthly(invoiceDateYearAsIntEq, invoiceDateMonthAsIntEq, canceledInvoiceIdEqNull, bookingInfosEqNull, isCanceledEq, isSendByMail, grossAmountGt, grossAmountLt, invoiceDateGt, invoiceDateLt, dueDateGt, dueDateLt, invoiceStateEq, invoiceNumberContains, numberRangeIdEq, companyNameContains, invoiceRecipientIdEq, pageNumber, pageSize, sortAttribute, sortDirection, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoicesApi.getTotalInvoiceAmountsMonthly']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [userId] 
         * @param {number} [month] 
         * @param {number} [year] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTotalInvoiceCountForMontAndYear(userId?: string, month?: number, year?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTotalInvoiceCountForMontAndYear(userId, month, year, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoicesApi.getTotalInvoiceCountForMontAndYear']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {MarkInvoiceAsPaidCommand} [markInvoiceAsPaidCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markInvoiceAsPaid(id: string, markInvoiceAsPaidCommand?: MarkInvoiceAsPaidCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markInvoiceAsPaid(id, markInvoiceAsPaidCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoicesApi.markInvoiceAsPaid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {MarkInvoiceAsPastDueCommand} [markInvoiceAsPastDueCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markInvoiceAsPastDue(id: string, markInvoiceAsPastDueCommand?: MarkInvoiceAsPastDueCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markInvoiceAsPastDue(id, markInvoiceAsPastDueCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoicesApi.markInvoiceAsPastDue']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {MarkInvoiceAsPendingCommand} [markInvoiceAsPendingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markInvoiceAsPending(id: string, markInvoiceAsPendingCommand?: MarkInvoiceAsPendingCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markInvoiceAsPending(id, markInvoiceAsPendingCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoicesApi.markInvoiceAsPending']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} invoiceId 
         * @param {RemoveCommentForInvoiceCommand} [removeCommentForInvoiceCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeCommentForInvoice(invoiceId: string, removeCommentForInvoiceCommand?: RemoveCommentForInvoiceCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeCommentForInvoice(invoiceId, removeCommentForInvoiceCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoicesApi.removeCommentForInvoice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {SendInvoiceByMailCommand} [sendInvoiceByMailCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async send(id: string, sendInvoiceByMailCommand?: SendInvoiceByMailCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.send(id, sendInvoiceByMailCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoicesApi.send']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InvoicesApi - factory interface
 */
export const InvoicesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InvoicesApiFp(configuration)
    return {
        /**
         * 
         * @param {InvoicesApiAddCommentForInvoiceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCommentForInvoice(requestParameters: InvoicesApiAddCommentForInvoiceRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.addCommentForInvoice(requestParameters.invoiceId, requestParameters.addCommentForInvoiceCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InvoicesApiBookInvoiceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookInvoice(requestParameters: InvoicesApiBookInvoiceRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.bookInvoice(requestParameters.id, requestParameters.bookInvoiceCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InvoicesApiCancelInvoiceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelInvoice(requestParameters: InvoicesApiCancelInvoiceRequest, options?: RawAxiosRequestConfig): AxiosPromise<InvoiceReadModel> {
            return localVarFp.cancelInvoice(requestParameters.id, requestParameters.cancelInvoiceCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InvoicesApiCreateInvoiceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInvoice(requestParameters: InvoicesApiCreateInvoiceRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AbstractReadModel> {
            return localVarFp.createInvoice(requestParameters.createInvoiceCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InvoicesApiCreateInvoiceAndSendRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInvoiceAndSend(requestParameters: InvoicesApiCreateInvoiceAndSendRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.createInvoiceAndSend(requestParameters.createAndSendInvoiceCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InvoicesApiCreateInvoicePreviewRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInvoicePreview(requestParameters: InvoicesApiCreateInvoicePreviewRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<InvoiceReadModel> {
            return localVarFp.createInvoicePreview(requestParameters.createInvoicePreviewCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InvoicesApiCreateInvoiceReminderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInvoiceReminder(requestParameters: InvoicesApiCreateInvoiceReminderRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createInvoiceReminder(requestParameters.id, requestParameters.createInvoiceReminderCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InvoicesApiCreateReverseInvoicePreviewRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createReverseInvoicePreview(requestParameters: InvoicesApiCreateReverseInvoicePreviewRequest, options?: RawAxiosRequestConfig): AxiosPromise<InvoiceReadModel> {
            return localVarFp.createReverseInvoicePreview(requestParameters.id, requestParameters.createReverseInvoicePreviewCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InvoicesApiDownloadPdfRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadPdf(requestParameters: InvoicesApiDownloadPdfRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.downloadPdf(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InvoicesApiGetInvoiceByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoiceById(requestParameters: InvoicesApiGetInvoiceByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<InvoiceReadModel> {
            return localVarFp.getInvoiceById(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InvoicesApiGetInvoicesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoices(requestParameters: InvoicesApiGetInvoicesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<InvoiceReadModel>> {
            return localVarFp.getInvoices(requestParameters.invoiceDateYearAsIntEq, requestParameters.invoiceDateMonthAsIntEq, requestParameters.canceledInvoiceIdEqNull, requestParameters.bookingInfosEqNull, requestParameters.isCanceledEq, requestParameters.isSendByMail, requestParameters.grossAmountGt, requestParameters.grossAmountLt, requestParameters.invoiceDateGt, requestParameters.invoiceDateLt, requestParameters.dueDateGt, requestParameters.dueDateLt, requestParameters.invoiceStateEq, requestParameters.invoiceNumberContains, requestParameters.numberRangeIdEq, requestParameters.companyNameContains, requestParameters.invoiceRecipientIdEq, requestParameters.pageNumber, requestParameters.pageSize, requestParameters.sortAttribute, requestParameters.sortDirection, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InvoicesApiGetTotalInvoiceAmountsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTotalInvoiceAmounts(requestParameters: InvoicesApiGetTotalInvoiceAmountsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<TotalInvoiceAmounts> {
            return localVarFp.getTotalInvoiceAmounts(requestParameters.invoiceDateYearAsIntEq, requestParameters.invoiceDateMonthAsIntEq, requestParameters.canceledInvoiceIdEqNull, requestParameters.bookingInfosEqNull, requestParameters.isCanceledEq, requestParameters.isSendByMail, requestParameters.grossAmountGt, requestParameters.grossAmountLt, requestParameters.invoiceDateGt, requestParameters.invoiceDateLt, requestParameters.dueDateGt, requestParameters.dueDateLt, requestParameters.invoiceStateEq, requestParameters.invoiceNumberContains, requestParameters.numberRangeIdEq, requestParameters.companyNameContains, requestParameters.invoiceRecipientIdEq, requestParameters.pageNumber, requestParameters.pageSize, requestParameters.sortAttribute, requestParameters.sortDirection, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InvoicesApiGetTotalInvoiceAmountsMonthlyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTotalInvoiceAmountsMonthly(requestParameters: InvoicesApiGetTotalInvoiceAmountsMonthlyRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<TotalInvoiceAmounts>> {
            return localVarFp.getTotalInvoiceAmountsMonthly(requestParameters.invoiceDateYearAsIntEq, requestParameters.invoiceDateMonthAsIntEq, requestParameters.canceledInvoiceIdEqNull, requestParameters.bookingInfosEqNull, requestParameters.isCanceledEq, requestParameters.isSendByMail, requestParameters.grossAmountGt, requestParameters.grossAmountLt, requestParameters.invoiceDateGt, requestParameters.invoiceDateLt, requestParameters.dueDateGt, requestParameters.dueDateLt, requestParameters.invoiceStateEq, requestParameters.invoiceNumberContains, requestParameters.numberRangeIdEq, requestParameters.companyNameContains, requestParameters.invoiceRecipientIdEq, requestParameters.pageNumber, requestParameters.pageSize, requestParameters.sortAttribute, requestParameters.sortDirection, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InvoicesApiGetTotalInvoiceCountForMontAndYearRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTotalInvoiceCountForMontAndYear(requestParameters: InvoicesApiGetTotalInvoiceCountForMontAndYearRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.getTotalInvoiceCountForMontAndYear(requestParameters.userId, requestParameters.month, requestParameters.year, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InvoicesApiMarkInvoiceAsPaidRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markInvoiceAsPaid(requestParameters: InvoicesApiMarkInvoiceAsPaidRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.markInvoiceAsPaid(requestParameters.id, requestParameters.markInvoiceAsPaidCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InvoicesApiMarkInvoiceAsPastDueRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markInvoiceAsPastDue(requestParameters: InvoicesApiMarkInvoiceAsPastDueRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.markInvoiceAsPastDue(requestParameters.id, requestParameters.markInvoiceAsPastDueCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InvoicesApiMarkInvoiceAsPendingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markInvoiceAsPending(requestParameters: InvoicesApiMarkInvoiceAsPendingRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.markInvoiceAsPending(requestParameters.id, requestParameters.markInvoiceAsPendingCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InvoicesApiRemoveCommentForInvoiceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeCommentForInvoice(requestParameters: InvoicesApiRemoveCommentForInvoiceRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.removeCommentForInvoice(requestParameters.invoiceId, requestParameters.removeCommentForInvoiceCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InvoicesApiSendRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        send(requestParameters: InvoicesApiSendRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.send(requestParameters.id, requestParameters.sendInvoiceByMailCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for addCommentForInvoice operation in InvoicesApi.
 */
export interface InvoicesApiAddCommentForInvoiceRequest {
    readonly invoiceId: string

    readonly addCommentForInvoiceCommand?: AddCommentForInvoiceCommand
}

/**
 * Request parameters for bookInvoice operation in InvoicesApi.
 */
export interface InvoicesApiBookInvoiceRequest {
    readonly id: string

    readonly bookInvoiceCommand?: BookInvoiceCommand
}

/**
 * Request parameters for cancelInvoice operation in InvoicesApi.
 */
export interface InvoicesApiCancelInvoiceRequest {
    readonly id: string

    readonly cancelInvoiceCommand?: CancelInvoiceCommand
}

/**
 * Request parameters for createInvoice operation in InvoicesApi.
 */
export interface InvoicesApiCreateInvoiceRequest {
    readonly createInvoiceCommand?: CreateInvoiceCommand
}

/**
 * Request parameters for createInvoiceAndSend operation in InvoicesApi.
 */
export interface InvoicesApiCreateInvoiceAndSendRequest {
    readonly createAndSendInvoiceCommand?: CreateAndSendInvoiceCommand
}

/**
 * Request parameters for createInvoicePreview operation in InvoicesApi.
 */
export interface InvoicesApiCreateInvoicePreviewRequest {
    readonly createInvoicePreviewCommand?: CreateInvoicePreviewCommand
}

/**
 * Request parameters for createInvoiceReminder operation in InvoicesApi.
 */
export interface InvoicesApiCreateInvoiceReminderRequest {
    readonly id: string

    readonly createInvoiceReminderCommand?: CreateInvoiceReminderCommand
}

/**
 * Request parameters for createReverseInvoicePreview operation in InvoicesApi.
 */
export interface InvoicesApiCreateReverseInvoicePreviewRequest {
    readonly id: string

    readonly createReverseInvoicePreviewCommand?: CreateReverseInvoicePreviewCommand
}

/**
 * Request parameters for downloadPdf operation in InvoicesApi.
 */
export interface InvoicesApiDownloadPdfRequest {
    readonly id: string
}

/**
 * Request parameters for getInvoiceById operation in InvoicesApi.
 */
export interface InvoicesApiGetInvoiceByIdRequest {
    readonly id: string
}

/**
 * Request parameters for getInvoices operation in InvoicesApi.
 */
export interface InvoicesApiGetInvoicesRequest {
    readonly invoiceDateYearAsIntEq?: number

    readonly invoiceDateMonthAsIntEq?: number

    readonly canceledInvoiceIdEqNull?: string

    readonly bookingInfosEqNull?: boolean

    readonly isCanceledEq?: boolean

    readonly isSendByMail?: boolean

    readonly grossAmountGt?: number

    readonly grossAmountLt?: number

    readonly invoiceDateGt?: string

    readonly invoiceDateLt?: string

    readonly dueDateGt?: string

    readonly dueDateLt?: string

    readonly invoiceStateEq?: Array<InvoiceState>

    readonly invoiceNumberContains?: string

    readonly numberRangeIdEq?: Array<string>

    readonly companyNameContains?: string

    readonly invoiceRecipientIdEq?: string

    readonly pageNumber?: number

    readonly pageSize?: number

    readonly sortAttribute?: string

    readonly sortDirection?: SortDirection
}

/**
 * Request parameters for getTotalInvoiceAmounts operation in InvoicesApi.
 */
export interface InvoicesApiGetTotalInvoiceAmountsRequest {
    readonly invoiceDateYearAsIntEq?: number

    readonly invoiceDateMonthAsIntEq?: number

    readonly canceledInvoiceIdEqNull?: string

    readonly bookingInfosEqNull?: boolean

    readonly isCanceledEq?: boolean

    readonly isSendByMail?: boolean

    readonly grossAmountGt?: number

    readonly grossAmountLt?: number

    readonly invoiceDateGt?: string

    readonly invoiceDateLt?: string

    readonly dueDateGt?: string

    readonly dueDateLt?: string

    readonly invoiceStateEq?: Array<InvoiceState>

    readonly invoiceNumberContains?: string

    readonly numberRangeIdEq?: Array<string>

    readonly companyNameContains?: string

    readonly invoiceRecipientIdEq?: string

    readonly pageNumber?: number

    readonly pageSize?: number

    readonly sortAttribute?: string

    readonly sortDirection?: SortDirection
}

/**
 * Request parameters for getTotalInvoiceAmountsMonthly operation in InvoicesApi.
 */
export interface InvoicesApiGetTotalInvoiceAmountsMonthlyRequest {
    readonly invoiceDateYearAsIntEq?: number

    readonly invoiceDateMonthAsIntEq?: number

    readonly canceledInvoiceIdEqNull?: string

    readonly bookingInfosEqNull?: boolean

    readonly isCanceledEq?: boolean

    readonly isSendByMail?: boolean

    readonly grossAmountGt?: number

    readonly grossAmountLt?: number

    readonly invoiceDateGt?: string

    readonly invoiceDateLt?: string

    readonly dueDateGt?: string

    readonly dueDateLt?: string

    readonly invoiceStateEq?: Array<InvoiceState>

    readonly invoiceNumberContains?: string

    readonly numberRangeIdEq?: Array<string>

    readonly companyNameContains?: string

    readonly invoiceRecipientIdEq?: string

    readonly pageNumber?: number

    readonly pageSize?: number

    readonly sortAttribute?: string

    readonly sortDirection?: SortDirection
}

/**
 * Request parameters for getTotalInvoiceCountForMontAndYear operation in InvoicesApi.
 */
export interface InvoicesApiGetTotalInvoiceCountForMontAndYearRequest {
    readonly userId?: string

    readonly month?: number

    readonly year?: number
}

/**
 * Request parameters for markInvoiceAsPaid operation in InvoicesApi.
 */
export interface InvoicesApiMarkInvoiceAsPaidRequest {
    readonly id: string

    readonly markInvoiceAsPaidCommand?: MarkInvoiceAsPaidCommand
}

/**
 * Request parameters for markInvoiceAsPastDue operation in InvoicesApi.
 */
export interface InvoicesApiMarkInvoiceAsPastDueRequest {
    readonly id: string

    readonly markInvoiceAsPastDueCommand?: MarkInvoiceAsPastDueCommand
}

/**
 * Request parameters for markInvoiceAsPending operation in InvoicesApi.
 */
export interface InvoicesApiMarkInvoiceAsPendingRequest {
    readonly id: string

    readonly markInvoiceAsPendingCommand?: MarkInvoiceAsPendingCommand
}

/**
 * Request parameters for removeCommentForInvoice operation in InvoicesApi.
 */
export interface InvoicesApiRemoveCommentForInvoiceRequest {
    readonly invoiceId: string

    readonly removeCommentForInvoiceCommand?: RemoveCommentForInvoiceCommand
}

/**
 * Request parameters for send operation in InvoicesApi.
 */
export interface InvoicesApiSendRequest {
    readonly id: string

    readonly sendInvoiceByMailCommand?: SendInvoiceByMailCommand
}

/**
 * InvoicesApi - object-oriented interface
 */
export class InvoicesApi extends BaseAPI {
    /**
     * 
     * @param {InvoicesApiAddCommentForInvoiceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addCommentForInvoice(requestParameters: InvoicesApiAddCommentForInvoiceRequest, options?: RawAxiosRequestConfig) {
        return InvoicesApiFp(this.configuration).addCommentForInvoice(requestParameters.invoiceId, requestParameters.addCommentForInvoiceCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InvoicesApiBookInvoiceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public bookInvoice(requestParameters: InvoicesApiBookInvoiceRequest, options?: RawAxiosRequestConfig) {
        return InvoicesApiFp(this.configuration).bookInvoice(requestParameters.id, requestParameters.bookInvoiceCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InvoicesApiCancelInvoiceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public cancelInvoice(requestParameters: InvoicesApiCancelInvoiceRequest, options?: RawAxiosRequestConfig) {
        return InvoicesApiFp(this.configuration).cancelInvoice(requestParameters.id, requestParameters.cancelInvoiceCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InvoicesApiCreateInvoiceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createInvoice(requestParameters: InvoicesApiCreateInvoiceRequest = {}, options?: RawAxiosRequestConfig) {
        return InvoicesApiFp(this.configuration).createInvoice(requestParameters.createInvoiceCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InvoicesApiCreateInvoiceAndSendRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createInvoiceAndSend(requestParameters: InvoicesApiCreateInvoiceAndSendRequest = {}, options?: RawAxiosRequestConfig) {
        return InvoicesApiFp(this.configuration).createInvoiceAndSend(requestParameters.createAndSendInvoiceCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InvoicesApiCreateInvoicePreviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createInvoicePreview(requestParameters: InvoicesApiCreateInvoicePreviewRequest = {}, options?: RawAxiosRequestConfig) {
        return InvoicesApiFp(this.configuration).createInvoicePreview(requestParameters.createInvoicePreviewCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InvoicesApiCreateInvoiceReminderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createInvoiceReminder(requestParameters: InvoicesApiCreateInvoiceReminderRequest, options?: RawAxiosRequestConfig) {
        return InvoicesApiFp(this.configuration).createInvoiceReminder(requestParameters.id, requestParameters.createInvoiceReminderCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InvoicesApiCreateReverseInvoicePreviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createReverseInvoicePreview(requestParameters: InvoicesApiCreateReverseInvoicePreviewRequest, options?: RawAxiosRequestConfig) {
        return InvoicesApiFp(this.configuration).createReverseInvoicePreview(requestParameters.id, requestParameters.createReverseInvoicePreviewCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InvoicesApiDownloadPdfRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public downloadPdf(requestParameters: InvoicesApiDownloadPdfRequest, options?: RawAxiosRequestConfig) {
        return InvoicesApiFp(this.configuration).downloadPdf(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InvoicesApiGetInvoiceByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getInvoiceById(requestParameters: InvoicesApiGetInvoiceByIdRequest, options?: RawAxiosRequestConfig) {
        return InvoicesApiFp(this.configuration).getInvoiceById(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InvoicesApiGetInvoicesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getInvoices(requestParameters: InvoicesApiGetInvoicesRequest = {}, options?: RawAxiosRequestConfig) {
        return InvoicesApiFp(this.configuration).getInvoices(requestParameters.invoiceDateYearAsIntEq, requestParameters.invoiceDateMonthAsIntEq, requestParameters.canceledInvoiceIdEqNull, requestParameters.bookingInfosEqNull, requestParameters.isCanceledEq, requestParameters.isSendByMail, requestParameters.grossAmountGt, requestParameters.grossAmountLt, requestParameters.invoiceDateGt, requestParameters.invoiceDateLt, requestParameters.dueDateGt, requestParameters.dueDateLt, requestParameters.invoiceStateEq, requestParameters.invoiceNumberContains, requestParameters.numberRangeIdEq, requestParameters.companyNameContains, requestParameters.invoiceRecipientIdEq, requestParameters.pageNumber, requestParameters.pageSize, requestParameters.sortAttribute, requestParameters.sortDirection, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InvoicesApiGetTotalInvoiceAmountsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getTotalInvoiceAmounts(requestParameters: InvoicesApiGetTotalInvoiceAmountsRequest = {}, options?: RawAxiosRequestConfig) {
        return InvoicesApiFp(this.configuration).getTotalInvoiceAmounts(requestParameters.invoiceDateYearAsIntEq, requestParameters.invoiceDateMonthAsIntEq, requestParameters.canceledInvoiceIdEqNull, requestParameters.bookingInfosEqNull, requestParameters.isCanceledEq, requestParameters.isSendByMail, requestParameters.grossAmountGt, requestParameters.grossAmountLt, requestParameters.invoiceDateGt, requestParameters.invoiceDateLt, requestParameters.dueDateGt, requestParameters.dueDateLt, requestParameters.invoiceStateEq, requestParameters.invoiceNumberContains, requestParameters.numberRangeIdEq, requestParameters.companyNameContains, requestParameters.invoiceRecipientIdEq, requestParameters.pageNumber, requestParameters.pageSize, requestParameters.sortAttribute, requestParameters.sortDirection, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InvoicesApiGetTotalInvoiceAmountsMonthlyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getTotalInvoiceAmountsMonthly(requestParameters: InvoicesApiGetTotalInvoiceAmountsMonthlyRequest = {}, options?: RawAxiosRequestConfig) {
        return InvoicesApiFp(this.configuration).getTotalInvoiceAmountsMonthly(requestParameters.invoiceDateYearAsIntEq, requestParameters.invoiceDateMonthAsIntEq, requestParameters.canceledInvoiceIdEqNull, requestParameters.bookingInfosEqNull, requestParameters.isCanceledEq, requestParameters.isSendByMail, requestParameters.grossAmountGt, requestParameters.grossAmountLt, requestParameters.invoiceDateGt, requestParameters.invoiceDateLt, requestParameters.dueDateGt, requestParameters.dueDateLt, requestParameters.invoiceStateEq, requestParameters.invoiceNumberContains, requestParameters.numberRangeIdEq, requestParameters.companyNameContains, requestParameters.invoiceRecipientIdEq, requestParameters.pageNumber, requestParameters.pageSize, requestParameters.sortAttribute, requestParameters.sortDirection, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InvoicesApiGetTotalInvoiceCountForMontAndYearRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getTotalInvoiceCountForMontAndYear(requestParameters: InvoicesApiGetTotalInvoiceCountForMontAndYearRequest = {}, options?: RawAxiosRequestConfig) {
        return InvoicesApiFp(this.configuration).getTotalInvoiceCountForMontAndYear(requestParameters.userId, requestParameters.month, requestParameters.year, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InvoicesApiMarkInvoiceAsPaidRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public markInvoiceAsPaid(requestParameters: InvoicesApiMarkInvoiceAsPaidRequest, options?: RawAxiosRequestConfig) {
        return InvoicesApiFp(this.configuration).markInvoiceAsPaid(requestParameters.id, requestParameters.markInvoiceAsPaidCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InvoicesApiMarkInvoiceAsPastDueRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public markInvoiceAsPastDue(requestParameters: InvoicesApiMarkInvoiceAsPastDueRequest, options?: RawAxiosRequestConfig) {
        return InvoicesApiFp(this.configuration).markInvoiceAsPastDue(requestParameters.id, requestParameters.markInvoiceAsPastDueCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InvoicesApiMarkInvoiceAsPendingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public markInvoiceAsPending(requestParameters: InvoicesApiMarkInvoiceAsPendingRequest, options?: RawAxiosRequestConfig) {
        return InvoicesApiFp(this.configuration).markInvoiceAsPending(requestParameters.id, requestParameters.markInvoiceAsPendingCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InvoicesApiRemoveCommentForInvoiceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public removeCommentForInvoice(requestParameters: InvoicesApiRemoveCommentForInvoiceRequest, options?: RawAxiosRequestConfig) {
        return InvoicesApiFp(this.configuration).removeCommentForInvoice(requestParameters.invoiceId, requestParameters.removeCommentForInvoiceCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InvoicesApiSendRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public send(requestParameters: InvoicesApiSendRequest, options?: RawAxiosRequestConfig) {
        return InvoicesApiFp(this.configuration).send(requestParameters.id, requestParameters.sendInvoiceByMailCommand, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * NumberRangesApi - axios parameter creator
 */
export const NumberRangesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {AddNumberRangeCommand} [addNumberRangeCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addNumberRange: async (addNumberRangeCommand?: AddNumberRangeCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/NumberRanges`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addNumberRangeCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNumberRangeById: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getNumberRangeById', 'id', id)
            const localVarPath = `/api/v1/NumberRanges/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [nameContains] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [sortAttribute] 
         * @param {SortDirection} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNumberRanges: async (nameContains?: string, pageNumber?: number, pageSize?: number, sortAttribute?: string, sortDirection?: SortDirection, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/NumberRanges`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (nameContains !== undefined) {
                localVarQueryParameter['Name_Contains'] = nameContains;
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['PageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['PageSize'] = pageSize;
            }

            if (sortAttribute !== undefined) {
                localVarQueryParameter['SortAttribute'] = sortAttribute;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['SortDirection'] = sortDirection;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeNumberRange: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('removeNumberRange', 'id', id)
            const localVarPath = `/api/v1/NumberRanges/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {SetNumberRangeToDefaultCommand} [setNumberRangeToDefaultCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setNumberRangeToDefault: async (id: string, setNumberRangeToDefaultCommand?: SetNumberRangeToDefaultCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('setNumberRangeToDefault', 'id', id)
            const localVarPath = `/api/v1/NumberRanges/{id}/SetNumberRangeToDefault`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setNumberRangeToDefaultCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateNumberRangeCommand} [updateNumberRangeCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNumberRange: async (id: string, updateNumberRangeCommand?: UpdateNumberRangeCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateNumberRange', 'id', id)
            const localVarPath = `/api/v1/NumberRanges/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateNumberRangeCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NumberRangesApi - functional programming interface
 */
export const NumberRangesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NumberRangesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {AddNumberRangeCommand} [addNumberRangeCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addNumberRange(addNumberRangeCommand?: AddNumberRangeCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NumberRangeReadModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addNumberRange(addNumberRangeCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NumberRangesApi.addNumberRange']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNumberRangeById(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NumberRangeReadModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNumberRangeById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NumberRangesApi.getNumberRangeById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [nameContains] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [sortAttribute] 
         * @param {SortDirection} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNumberRanges(nameContains?: string, pageNumber?: number, pageSize?: number, sortAttribute?: string, sortDirection?: SortDirection, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NumberRangeReadModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNumberRanges(nameContains, pageNumber, pageSize, sortAttribute, sortDirection, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NumberRangesApi.getNumberRanges']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeNumberRange(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeNumberRange(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NumberRangesApi.removeNumberRange']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {SetNumberRangeToDefaultCommand} [setNumberRangeToDefaultCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setNumberRangeToDefault(id: string, setNumberRangeToDefaultCommand?: SetNumberRangeToDefaultCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setNumberRangeToDefault(id, setNumberRangeToDefaultCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NumberRangesApi.setNumberRangeToDefault']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateNumberRangeCommand} [updateNumberRangeCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateNumberRange(id: string, updateNumberRangeCommand?: UpdateNumberRangeCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AbstractModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateNumberRange(id, updateNumberRangeCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NumberRangesApi.updateNumberRange']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NumberRangesApi - factory interface
 */
export const NumberRangesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NumberRangesApiFp(configuration)
    return {
        /**
         * 
         * @param {NumberRangesApiAddNumberRangeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addNumberRange(requestParameters: NumberRangesApiAddNumberRangeRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<NumberRangeReadModel> {
            return localVarFp.addNumberRange(requestParameters.addNumberRangeCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {NumberRangesApiGetNumberRangeByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNumberRangeById(requestParameters: NumberRangesApiGetNumberRangeByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<NumberRangeReadModel> {
            return localVarFp.getNumberRangeById(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {NumberRangesApiGetNumberRangesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNumberRanges(requestParameters: NumberRangesApiGetNumberRangesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<NumberRangeReadModel>> {
            return localVarFp.getNumberRanges(requestParameters.nameContains, requestParameters.pageNumber, requestParameters.pageSize, requestParameters.sortAttribute, requestParameters.sortDirection, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {NumberRangesApiRemoveNumberRangeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeNumberRange(requestParameters: NumberRangesApiRemoveNumberRangeRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.removeNumberRange(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {NumberRangesApiSetNumberRangeToDefaultRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setNumberRangeToDefault(requestParameters: NumberRangesApiSetNumberRangeToDefaultRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.setNumberRangeToDefault(requestParameters.id, requestParameters.setNumberRangeToDefaultCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {NumberRangesApiUpdateNumberRangeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNumberRange(requestParameters: NumberRangesApiUpdateNumberRangeRequest, options?: RawAxiosRequestConfig): AxiosPromise<AbstractModel> {
            return localVarFp.updateNumberRange(requestParameters.id, requestParameters.updateNumberRangeCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for addNumberRange operation in NumberRangesApi.
 */
export interface NumberRangesApiAddNumberRangeRequest {
    readonly addNumberRangeCommand?: AddNumberRangeCommand
}

/**
 * Request parameters for getNumberRangeById operation in NumberRangesApi.
 */
export interface NumberRangesApiGetNumberRangeByIdRequest {
    readonly id: string
}

/**
 * Request parameters for getNumberRanges operation in NumberRangesApi.
 */
export interface NumberRangesApiGetNumberRangesRequest {
    readonly nameContains?: string

    readonly pageNumber?: number

    readonly pageSize?: number

    readonly sortAttribute?: string

    readonly sortDirection?: SortDirection
}

/**
 * Request parameters for removeNumberRange operation in NumberRangesApi.
 */
export interface NumberRangesApiRemoveNumberRangeRequest {
    readonly id: string
}

/**
 * Request parameters for setNumberRangeToDefault operation in NumberRangesApi.
 */
export interface NumberRangesApiSetNumberRangeToDefaultRequest {
    readonly id: string

    readonly setNumberRangeToDefaultCommand?: SetNumberRangeToDefaultCommand
}

/**
 * Request parameters for updateNumberRange operation in NumberRangesApi.
 */
export interface NumberRangesApiUpdateNumberRangeRequest {
    readonly id: string

    readonly updateNumberRangeCommand?: UpdateNumberRangeCommand
}

/**
 * NumberRangesApi - object-oriented interface
 */
export class NumberRangesApi extends BaseAPI {
    /**
     * 
     * @param {NumberRangesApiAddNumberRangeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addNumberRange(requestParameters: NumberRangesApiAddNumberRangeRequest = {}, options?: RawAxiosRequestConfig) {
        return NumberRangesApiFp(this.configuration).addNumberRange(requestParameters.addNumberRangeCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {NumberRangesApiGetNumberRangeByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getNumberRangeById(requestParameters: NumberRangesApiGetNumberRangeByIdRequest, options?: RawAxiosRequestConfig) {
        return NumberRangesApiFp(this.configuration).getNumberRangeById(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {NumberRangesApiGetNumberRangesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getNumberRanges(requestParameters: NumberRangesApiGetNumberRangesRequest = {}, options?: RawAxiosRequestConfig) {
        return NumberRangesApiFp(this.configuration).getNumberRanges(requestParameters.nameContains, requestParameters.pageNumber, requestParameters.pageSize, requestParameters.sortAttribute, requestParameters.sortDirection, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {NumberRangesApiRemoveNumberRangeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public removeNumberRange(requestParameters: NumberRangesApiRemoveNumberRangeRequest, options?: RawAxiosRequestConfig) {
        return NumberRangesApiFp(this.configuration).removeNumberRange(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {NumberRangesApiSetNumberRangeToDefaultRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public setNumberRangeToDefault(requestParameters: NumberRangesApiSetNumberRangeToDefaultRequest, options?: RawAxiosRequestConfig) {
        return NumberRangesApiFp(this.configuration).setNumberRangeToDefault(requestParameters.id, requestParameters.setNumberRangeToDefaultCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {NumberRangesApiUpdateNumberRangeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateNumberRange(requestParameters: NumberRangesApiUpdateNumberRangeRequest, options?: RawAxiosRequestConfig) {
        return NumberRangesApiFp(this.configuration).updateNumberRange(requestParameters.id, requestParameters.updateNumberRangeCommand, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProductsApi - axios parameter creator
 */
export const ProductsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {AddProductCommand} [addProductCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addProduct: async (addProductCommand?: AddProductCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addProductCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductById: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getProductById', 'id', id)
            const localVarPath = `/api/v1/Products/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [productNameContains] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [sortAttribute] 
         * @param {SortDirection} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProducts: async (productNameContains?: string, pageNumber?: number, pageSize?: number, sortAttribute?: string, sortDirection?: SortDirection, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (productNameContains !== undefined) {
                localVarQueryParameter['ProductName_Contains'] = productNameContains;
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['PageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['PageSize'] = pageSize;
            }

            if (sortAttribute !== undefined) {
                localVarQueryParameter['SortAttribute'] = sortAttribute;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['SortDirection'] = sortDirection;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeProduct: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('removeProduct', 'id', id)
            const localVarPath = `/api/v1/Products/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateProductCommand} [updateProductCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProduct: async (id: string, updateProductCommand?: UpdateProductCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateProduct', 'id', id)
            const localVarPath = `/api/v1/Products/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProductCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductsApi - functional programming interface
 */
export const ProductsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {AddProductCommand} [addProductCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addProduct(addProductCommand?: AddProductCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductReadModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addProduct(addProductCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.addProduct']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductById(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductReadModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.getProductById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [productNameContains] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [sortAttribute] 
         * @param {SortDirection} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProducts(productNameContains?: string, pageNumber?: number, pageSize?: number, sortAttribute?: string, sortDirection?: SortDirection, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProductReadModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProducts(productNameContains, pageNumber, pageSize, sortAttribute, sortDirection, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.getProducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeProduct(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductReadModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeProduct(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.removeProduct']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateProductCommand} [updateProductCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProduct(id: string, updateProductCommand?: UpdateProductCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductReadModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProduct(id, updateProductCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.updateProduct']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProductsApi - factory interface
 */
export const ProductsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductsApiFp(configuration)
    return {
        /**
         * 
         * @param {ProductsApiAddProductRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addProduct(requestParameters: ProductsApiAddProductRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ProductReadModel> {
            return localVarFp.addProduct(requestParameters.addProductCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ProductsApiGetProductByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductById(requestParameters: ProductsApiGetProductByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProductReadModel> {
            return localVarFp.getProductById(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ProductsApiGetProductsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProducts(requestParameters: ProductsApiGetProductsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<ProductReadModel>> {
            return localVarFp.getProducts(requestParameters.productNameContains, requestParameters.pageNumber, requestParameters.pageSize, requestParameters.sortAttribute, requestParameters.sortDirection, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ProductsApiRemoveProductRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeProduct(requestParameters: ProductsApiRemoveProductRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProductReadModel> {
            return localVarFp.removeProduct(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ProductsApiUpdateProductRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProduct(requestParameters: ProductsApiUpdateProductRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProductReadModel> {
            return localVarFp.updateProduct(requestParameters.id, requestParameters.updateProductCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for addProduct operation in ProductsApi.
 */
export interface ProductsApiAddProductRequest {
    readonly addProductCommand?: AddProductCommand
}

/**
 * Request parameters for getProductById operation in ProductsApi.
 */
export interface ProductsApiGetProductByIdRequest {
    readonly id: string
}

/**
 * Request parameters for getProducts operation in ProductsApi.
 */
export interface ProductsApiGetProductsRequest {
    readonly productNameContains?: string

    readonly pageNumber?: number

    readonly pageSize?: number

    readonly sortAttribute?: string

    readonly sortDirection?: SortDirection
}

/**
 * Request parameters for removeProduct operation in ProductsApi.
 */
export interface ProductsApiRemoveProductRequest {
    readonly id: string
}

/**
 * Request parameters for updateProduct operation in ProductsApi.
 */
export interface ProductsApiUpdateProductRequest {
    readonly id: string

    readonly updateProductCommand?: UpdateProductCommand
}

/**
 * ProductsApi - object-oriented interface
 */
export class ProductsApi extends BaseAPI {
    /**
     * 
     * @param {ProductsApiAddProductRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addProduct(requestParameters: ProductsApiAddProductRequest = {}, options?: RawAxiosRequestConfig) {
        return ProductsApiFp(this.configuration).addProduct(requestParameters.addProductCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ProductsApiGetProductByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProductById(requestParameters: ProductsApiGetProductByIdRequest, options?: RawAxiosRequestConfig) {
        return ProductsApiFp(this.configuration).getProductById(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ProductsApiGetProductsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProducts(requestParameters: ProductsApiGetProductsRequest = {}, options?: RawAxiosRequestConfig) {
        return ProductsApiFp(this.configuration).getProducts(requestParameters.productNameContains, requestParameters.pageNumber, requestParameters.pageSize, requestParameters.sortAttribute, requestParameters.sortDirection, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ProductsApiRemoveProductRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public removeProduct(requestParameters: ProductsApiRemoveProductRequest, options?: RawAxiosRequestConfig) {
        return ProductsApiFp(this.configuration).removeProduct(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ProductsApiUpdateProductRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateProduct(requestParameters: ProductsApiUpdateProductRequest, options?: RawAxiosRequestConfig) {
        return ProductsApiFp(this.configuration).updateProduct(requestParameters.id, requestParameters.updateProductCommand, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RevenuesAccountsApi - axios parameter creator
 */
export const RevenuesAccountsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [userId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRevenuesAccounts: async (userId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/RevenuesAccounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RevenuesAccountsApi - functional programming interface
 */
export const RevenuesAccountsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RevenuesAccountsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [userId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRevenuesAccounts(userId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RevenuesAccountReadModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRevenuesAccounts(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RevenuesAccountsApi.getRevenuesAccounts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RevenuesAccountsApi - factory interface
 */
export const RevenuesAccountsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RevenuesAccountsApiFp(configuration)
    return {
        /**
         * 
         * @param {RevenuesAccountsApiGetRevenuesAccountsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRevenuesAccounts(requestParameters: RevenuesAccountsApiGetRevenuesAccountsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<RevenuesAccountReadModel>> {
            return localVarFp.getRevenuesAccounts(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getRevenuesAccounts operation in RevenuesAccountsApi.
 */
export interface RevenuesAccountsApiGetRevenuesAccountsRequest {
    readonly userId?: string
}

/**
 * RevenuesAccountsApi - object-oriented interface
 */
export class RevenuesAccountsApi extends BaseAPI {
    /**
     * 
     * @param {RevenuesAccountsApiGetRevenuesAccountsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getRevenuesAccounts(requestParameters: RevenuesAccountsApiGetRevenuesAccountsRequest = {}, options?: RawAxiosRequestConfig) {
        return RevenuesAccountsApiFp(this.configuration).getRevenuesAccounts(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ReverseInvoicesApi - axios parameter creator
 */
export const ReverseInvoicesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} reverseInvoiceId 
         * @param {AddCommentForReverseInvoiceCommand} [addCommentForReverseInvoiceCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCommentForReverseInvoice: async (reverseInvoiceId: string, addCommentForReverseInvoiceCommand?: AddCommentForReverseInvoiceCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reverseInvoiceId' is not null or undefined
            assertParamExists('addCommentForReverseInvoice', 'reverseInvoiceId', reverseInvoiceId)
            const localVarPath = `/api/v1/ReverseInvoices/{reverseInvoiceId}/AddCommentForReverseInvoice`
                .replace('{reverseInvoiceId}', encodeURIComponent(String(reverseInvoiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addCommentForReverseInvoiceCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {BookReverseInvoiceCommand} [bookReverseInvoiceCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookReverseInvoice: async (id: string, bookReverseInvoiceCommand?: BookReverseInvoiceCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('bookReverseInvoice', 'id', id)
            const localVarPath = `/api/v1/ReverseInvoices/{id}/BookReverseInvoice`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bookReverseInvoiceCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadReverseInvoice: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('downloadReverseInvoice', 'id', id)
            const localVarPath = `/api/v1/ReverseInvoices/{id}/Pdf`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/pdf,application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} canceledInvoiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReverseInvoiceByCanceledInvoiceId: async (canceledInvoiceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'canceledInvoiceId' is not null or undefined
            assertParamExists('getReverseInvoiceByCanceledInvoiceId', 'canceledInvoiceId', canceledInvoiceId)
            const localVarPath = `/api/v1/ReverseInvoices/ByCanceledInvoice/{canceledInvoiceId}`
                .replace('{canceledInvoiceId}', encodeURIComponent(String(canceledInvoiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReverseInvoiceById: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getReverseInvoiceById', 'id', id)
            const localVarPath = `/api/v1/ReverseInvoices/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {object} [filter] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [sortAttribute] 
         * @param {SortDirection} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReverseInvoices: async (filter?: object, pageNumber?: number, pageSize?: number, sortAttribute?: string, sortDirection?: SortDirection, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ReverseInvoices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filter !== undefined) {
                for (const [key, value] of Object.entries(filter)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['PageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['PageSize'] = pageSize;
            }

            if (sortAttribute !== undefined) {
                localVarQueryParameter['SortAttribute'] = sortAttribute;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['SortDirection'] = sortDirection;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} reverseInvoiceId 
         * @param {RemoveCommentForReverseInvoiceCommand} [removeCommentForReverseInvoiceCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeCommentForReverseInvoice: async (reverseInvoiceId: string, removeCommentForReverseInvoiceCommand?: RemoveCommentForReverseInvoiceCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reverseInvoiceId' is not null or undefined
            assertParamExists('removeCommentForReverseInvoice', 'reverseInvoiceId', reverseInvoiceId)
            const localVarPath = `/api/v1/ReverseInvoices/{reverseInvoiceId}/RemoveCommentForReverseInvoice`
                .replace('{reverseInvoiceId}', encodeURIComponent(String(reverseInvoiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(removeCommentForReverseInvoiceCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {SendReverseInvoiceByMailCommand} [sendReverseInvoiceByMailCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendReverseInvoice: async (id: string, sendReverseInvoiceByMailCommand?: SendReverseInvoiceByMailCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('sendReverseInvoice', 'id', id)
            const localVarPath = `/api/v1/ReverseInvoices/{id}/Send`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendReverseInvoiceByMailCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReverseInvoicesApi - functional programming interface
 */
export const ReverseInvoicesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReverseInvoicesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} reverseInvoiceId 
         * @param {AddCommentForReverseInvoiceCommand} [addCommentForReverseInvoiceCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addCommentForReverseInvoice(reverseInvoiceId: string, addCommentForReverseInvoiceCommand?: AddCommentForReverseInvoiceCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addCommentForReverseInvoice(reverseInvoiceId, addCommentForReverseInvoiceCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReverseInvoicesApi.addCommentForReverseInvoice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {BookReverseInvoiceCommand} [bookReverseInvoiceCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bookReverseInvoice(id: string, bookReverseInvoiceCommand?: BookReverseInvoiceCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bookReverseInvoice(id, bookReverseInvoiceCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReverseInvoicesApi.bookReverseInvoice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadReverseInvoice(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadReverseInvoice(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReverseInvoicesApi.downloadReverseInvoice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} canceledInvoiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReverseInvoiceByCanceledInvoiceId(canceledInvoiceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReverseInvoiceReadModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReverseInvoiceByCanceledInvoiceId(canceledInvoiceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReverseInvoicesApi.getReverseInvoiceByCanceledInvoiceId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReverseInvoiceById(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReverseInvoiceReadModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReverseInvoiceById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReverseInvoicesApi.getReverseInvoiceById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {object} [filter] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [sortAttribute] 
         * @param {SortDirection} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReverseInvoices(filter?: object, pageNumber?: number, pageSize?: number, sortAttribute?: string, sortDirection?: SortDirection, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ReverseInvoiceReadModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReverseInvoices(filter, pageNumber, pageSize, sortAttribute, sortDirection, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReverseInvoicesApi.getReverseInvoices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} reverseInvoiceId 
         * @param {RemoveCommentForReverseInvoiceCommand} [removeCommentForReverseInvoiceCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeCommentForReverseInvoice(reverseInvoiceId: string, removeCommentForReverseInvoiceCommand?: RemoveCommentForReverseInvoiceCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeCommentForReverseInvoice(reverseInvoiceId, removeCommentForReverseInvoiceCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReverseInvoicesApi.removeCommentForReverseInvoice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {SendReverseInvoiceByMailCommand} [sendReverseInvoiceByMailCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendReverseInvoice(id: string, sendReverseInvoiceByMailCommand?: SendReverseInvoiceByMailCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendReverseInvoice(id, sendReverseInvoiceByMailCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReverseInvoicesApi.sendReverseInvoice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ReverseInvoicesApi - factory interface
 */
export const ReverseInvoicesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReverseInvoicesApiFp(configuration)
    return {
        /**
         * 
         * @param {ReverseInvoicesApiAddCommentForReverseInvoiceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCommentForReverseInvoice(requestParameters: ReverseInvoicesApiAddCommentForReverseInvoiceRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.addCommentForReverseInvoice(requestParameters.reverseInvoiceId, requestParameters.addCommentForReverseInvoiceCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReverseInvoicesApiBookReverseInvoiceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookReverseInvoice(requestParameters: ReverseInvoicesApiBookReverseInvoiceRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.bookReverseInvoice(requestParameters.id, requestParameters.bookReverseInvoiceCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReverseInvoicesApiDownloadReverseInvoiceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadReverseInvoice(requestParameters: ReverseInvoicesApiDownloadReverseInvoiceRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.downloadReverseInvoice(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReverseInvoicesApiGetReverseInvoiceByCanceledInvoiceIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReverseInvoiceByCanceledInvoiceId(requestParameters: ReverseInvoicesApiGetReverseInvoiceByCanceledInvoiceIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReverseInvoiceReadModel> {
            return localVarFp.getReverseInvoiceByCanceledInvoiceId(requestParameters.canceledInvoiceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReverseInvoicesApiGetReverseInvoiceByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReverseInvoiceById(requestParameters: ReverseInvoicesApiGetReverseInvoiceByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReverseInvoiceReadModel> {
            return localVarFp.getReverseInvoiceById(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReverseInvoicesApiGetReverseInvoicesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReverseInvoices(requestParameters: ReverseInvoicesApiGetReverseInvoicesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<ReverseInvoiceReadModel>> {
            return localVarFp.getReverseInvoices(requestParameters.filter, requestParameters.pageNumber, requestParameters.pageSize, requestParameters.sortAttribute, requestParameters.sortDirection, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReverseInvoicesApiRemoveCommentForReverseInvoiceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeCommentForReverseInvoice(requestParameters: ReverseInvoicesApiRemoveCommentForReverseInvoiceRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.removeCommentForReverseInvoice(requestParameters.reverseInvoiceId, requestParameters.removeCommentForReverseInvoiceCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReverseInvoicesApiSendReverseInvoiceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendReverseInvoice(requestParameters: ReverseInvoicesApiSendReverseInvoiceRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.sendReverseInvoice(requestParameters.id, requestParameters.sendReverseInvoiceByMailCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for addCommentForReverseInvoice operation in ReverseInvoicesApi.
 */
export interface ReverseInvoicesApiAddCommentForReverseInvoiceRequest {
    readonly reverseInvoiceId: string

    readonly addCommentForReverseInvoiceCommand?: AddCommentForReverseInvoiceCommand
}

/**
 * Request parameters for bookReverseInvoice operation in ReverseInvoicesApi.
 */
export interface ReverseInvoicesApiBookReverseInvoiceRequest {
    readonly id: string

    readonly bookReverseInvoiceCommand?: BookReverseInvoiceCommand
}

/**
 * Request parameters for downloadReverseInvoice operation in ReverseInvoicesApi.
 */
export interface ReverseInvoicesApiDownloadReverseInvoiceRequest {
    readonly id: string
}

/**
 * Request parameters for getReverseInvoiceByCanceledInvoiceId operation in ReverseInvoicesApi.
 */
export interface ReverseInvoicesApiGetReverseInvoiceByCanceledInvoiceIdRequest {
    readonly canceledInvoiceId: string
}

/**
 * Request parameters for getReverseInvoiceById operation in ReverseInvoicesApi.
 */
export interface ReverseInvoicesApiGetReverseInvoiceByIdRequest {
    readonly id: string
}

/**
 * Request parameters for getReverseInvoices operation in ReverseInvoicesApi.
 */
export interface ReverseInvoicesApiGetReverseInvoicesRequest {
    readonly filter?: object

    readonly pageNumber?: number

    readonly pageSize?: number

    readonly sortAttribute?: string

    readonly sortDirection?: SortDirection
}

/**
 * Request parameters for removeCommentForReverseInvoice operation in ReverseInvoicesApi.
 */
export interface ReverseInvoicesApiRemoveCommentForReverseInvoiceRequest {
    readonly reverseInvoiceId: string

    readonly removeCommentForReverseInvoiceCommand?: RemoveCommentForReverseInvoiceCommand
}

/**
 * Request parameters for sendReverseInvoice operation in ReverseInvoicesApi.
 */
export interface ReverseInvoicesApiSendReverseInvoiceRequest {
    readonly id: string

    readonly sendReverseInvoiceByMailCommand?: SendReverseInvoiceByMailCommand
}

/**
 * ReverseInvoicesApi - object-oriented interface
 */
export class ReverseInvoicesApi extends BaseAPI {
    /**
     * 
     * @param {ReverseInvoicesApiAddCommentForReverseInvoiceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addCommentForReverseInvoice(requestParameters: ReverseInvoicesApiAddCommentForReverseInvoiceRequest, options?: RawAxiosRequestConfig) {
        return ReverseInvoicesApiFp(this.configuration).addCommentForReverseInvoice(requestParameters.reverseInvoiceId, requestParameters.addCommentForReverseInvoiceCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReverseInvoicesApiBookReverseInvoiceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public bookReverseInvoice(requestParameters: ReverseInvoicesApiBookReverseInvoiceRequest, options?: RawAxiosRequestConfig) {
        return ReverseInvoicesApiFp(this.configuration).bookReverseInvoice(requestParameters.id, requestParameters.bookReverseInvoiceCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReverseInvoicesApiDownloadReverseInvoiceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public downloadReverseInvoice(requestParameters: ReverseInvoicesApiDownloadReverseInvoiceRequest, options?: RawAxiosRequestConfig) {
        return ReverseInvoicesApiFp(this.configuration).downloadReverseInvoice(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReverseInvoicesApiGetReverseInvoiceByCanceledInvoiceIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getReverseInvoiceByCanceledInvoiceId(requestParameters: ReverseInvoicesApiGetReverseInvoiceByCanceledInvoiceIdRequest, options?: RawAxiosRequestConfig) {
        return ReverseInvoicesApiFp(this.configuration).getReverseInvoiceByCanceledInvoiceId(requestParameters.canceledInvoiceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReverseInvoicesApiGetReverseInvoiceByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getReverseInvoiceById(requestParameters: ReverseInvoicesApiGetReverseInvoiceByIdRequest, options?: RawAxiosRequestConfig) {
        return ReverseInvoicesApiFp(this.configuration).getReverseInvoiceById(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReverseInvoicesApiGetReverseInvoicesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getReverseInvoices(requestParameters: ReverseInvoicesApiGetReverseInvoicesRequest = {}, options?: RawAxiosRequestConfig) {
        return ReverseInvoicesApiFp(this.configuration).getReverseInvoices(requestParameters.filter, requestParameters.pageNumber, requestParameters.pageSize, requestParameters.sortAttribute, requestParameters.sortDirection, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReverseInvoicesApiRemoveCommentForReverseInvoiceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public removeCommentForReverseInvoice(requestParameters: ReverseInvoicesApiRemoveCommentForReverseInvoiceRequest, options?: RawAxiosRequestConfig) {
        return ReverseInvoicesApiFp(this.configuration).removeCommentForReverseInvoice(requestParameters.reverseInvoiceId, requestParameters.removeCommentForReverseInvoiceCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReverseInvoicesApiSendReverseInvoiceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public sendReverseInvoice(requestParameters: ReverseInvoicesApiSendReverseInvoiceRequest, options?: RawAxiosRequestConfig) {
        return ReverseInvoicesApiFp(this.configuration).sendReverseInvoice(requestParameters.id, requestParameters.sendReverseInvoiceByMailCommand, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UsersApi - axios parameter creator
 */
export const UsersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {AddLogoCommand} [addLogoCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addLogo: async (id: string, addLogoCommand?: AddLogoCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('addLogo', 'id', id)
            const localVarPath = `/api/v1/Users/{id}/AddLogo`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addLogoCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {AddTextModelCommand} [addTextModelCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTextModel: async (id: string, addTextModelCommand?: AddTextModelCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('addTextModel', 'id', id)
            const localVarPath = `/api/v1/Users/{id}/AddTextModel`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addTextModelCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {AddTextModelEmailCommand} [addTextModelEmailCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTextModelEmail: async (id: string, addTextModelEmailCommand?: AddTextModelEmailCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('addTextModelEmail', 'id', id)
            const localVarPath = `/api/v1/Users/{id}/AddTextModelEmail`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addTextModelEmailCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ImportUserCommand} [importUserCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUser: async (importUserCommand?: ImportUserCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(importUserCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ChangeBookingPeriodCommand} [changeBookingPeriodCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeBookingPeriod: async (changeBookingPeriodCommand?: ChangeBookingPeriodCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Users/ChangeBookingPeriod`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changeBookingPeriodCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {ConfigureMailServiceCommand} [configureMailServiceCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configureMailService: async (id: string, configureMailServiceCommand?: ConfigureMailServiceCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('configureMailService', 'id', id)
            const localVarPath = `/api/v1/Users/{id}/ConfigureMailService`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(configureMailServiceCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateOrFixTaxNumberCommand} [createOrFixTaxNumberCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrFixTaxNumber: async (createOrFixTaxNumberCommand?: CreateOrFixTaxNumberCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Users/CreateOrFixTaxNumber`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createOrFixTaxNumberCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveSubscriptions: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getActiveSubscriptions', 'id', id)
            const localVarPath = `/api/v1/Users/{id}/activeSubscriptions`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserById: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getUserById', 'id', id)
            const localVarPath = `/api/v1/Users/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {object} [filter] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [sortAttribute] 
         * @param {SortDirection} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsers: async (filter?: object, pageNumber?: number, pageSize?: number, sortAttribute?: string, sortDirection?: SortDirection, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filter !== undefined) {
                for (const [key, value] of Object.entries(filter)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['PageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['PageSize'] = pageSize;
            }

            if (sortAttribute !== undefined) {
                localVarQueryParameter['SortAttribute'] = sortAttribute;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['SortDirection'] = sortDirection;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} [sessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isUserAuthenticated: async (id: string, sessionId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('isUserAuthenticated', 'id', id)
            const localVarPath = `/api/v1/Users/{id}/isAuthenticated`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sessionId !== undefined) {
                localVarQueryParameter['sessionId'] = sessionId;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {LoginCommand} [loginCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login: async (loginCommand?: LoginCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Users/Login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Login2FaCommand} [login2FaCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login2Fa: async (login2FaCommand?: Login2FaCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Users/Login2Fa`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(login2FaCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {LogoutCommand} [logoutCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout: async (logoutCommand?: LogoutCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Users/Logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(logoutCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userId 
         * @param {MailServiceConfigTestQuery} [mailServiceConfigTestQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailServiceConfigTest: async (userId: string, mailServiceConfigTestQuery?: MailServiceConfigTestQuery, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('mailServiceConfigTest', 'userId', userId)
            const localVarPath = `/api/v1/Users/{userId}/MailServiceConfigTest`
                .replace('{userId}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(mailServiceConfigTestQuery, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userId 
         * @param {OrderSubscriptionCommand} [orderSubscriptionCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderSubscription: async (userId: string, orderSubscriptionCommand?: OrderSubscriptionCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('orderSubscription', 'userId', userId)
            const localVarPath = `/api/v1/Users/{userId}/orderSubscription`
                .replace('{userId}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(orderSubscriptionCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RegisterCommand} [registerCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        register: async (registerCommand?: RegisterCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Users/Register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registerCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {RemoveLogoCommand} [removeLogoCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeLogo: async (id: string, removeLogoCommand?: RemoveLogoCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('removeLogo', 'id', id)
            const localVarPath = `/api/v1/Users/{id}/RemoveLogo`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(removeLogoCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {RemoveMailServiceConfigurationCommand} [removeMailServiceConfigurationCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeMailServiceConfiguration: async (id: string, removeMailServiceConfigurationCommand?: RemoveMailServiceConfigurationCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('removeMailServiceConfiguration', 'id', id)
            const localVarPath = `/api/v1/Users/{id}/RemoveMailServiceConfiguration`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(removeMailServiceConfigurationCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {RemoveTextModelCommand} [removeTextModelCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeTextModel: async (id: string, removeTextModelCommand?: RemoveTextModelCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('removeTextModel', 'id', id)
            const localVarPath = `/api/v1/Users/{id}/RemoveTextModel`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(removeTextModelCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {RemoveTextModelEmailCommand} [removeTextModelEmailCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeTextModelEmail: async (id: string, removeTextModelEmailCommand?: RemoveTextModelEmailCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('removeTextModelEmail', 'id', id)
            const localVarPath = `/api/v1/Users/{id}/RemoveTextModelEmail`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(removeTextModelEmailCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ResetPasswordCommand} [resetPasswordCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword: async (resetPasswordCommand?: ResetPasswordCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Users/ResetPassword`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resetPasswordCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SendPasswordResetMailCommand} [sendPasswordResetMailCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendPasswordResetMail: async (sendPasswordResetMailCommand?: SendPasswordResetMailCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Users/SendPasswordResetMail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendPasswordResetMailCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SetupUserLoginCommand} [setupUserLoginCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setupUserLogin: async (setupUserLoginCommand?: SetupUserLoginCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Users/SetupUserLogin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setupUserLoginCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateUserCommand} [updateUserCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser: async (id: string, updateUserCommand?: UpdateUserCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateUser', 'id', id)
            const localVarPath = `/api/v1/Users/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [taxNumber] 
         * @param {FederalState} [federalState] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateTaxNumber: async (taxNumber?: string, federalState?: FederalState, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Users/ValidateTaxNumber`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (taxNumber !== undefined) {
                localVarQueryParameter['taxNumber'] = taxNumber;
            }

            if (federalState !== undefined) {
                localVarQueryParameter['federalState'] = federalState;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UsersApi - functional programming interface
 */
export const UsersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UsersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {AddLogoCommand} [addLogoCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addLogo(id: string, addLogoCommand?: AddLogoCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AbstractModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addLogo(id, addLogoCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.addLogo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {AddTextModelCommand} [addTextModelCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addTextModel(id: string, addTextModelCommand?: AddTextModelCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AbstractModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addTextModel(id, addTextModelCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.addTextModel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {AddTextModelEmailCommand} [addTextModelEmailCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addTextModelEmail(id: string, addTextModelEmailCommand?: AddTextModelEmailCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AbstractModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addTextModelEmail(id, addTextModelEmailCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.addTextModelEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ImportUserCommand} [importUserCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addUser(importUserCommand?: ImportUserCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserReadModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addUser(importUserCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.addUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ChangeBookingPeriodCommand} [changeBookingPeriodCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeBookingPeriod(changeBookingPeriodCommand?: ChangeBookingPeriodCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeBookingPeriod(changeBookingPeriodCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.changeBookingPeriod']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {ConfigureMailServiceCommand} [configureMailServiceCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async configureMailService(id: string, configureMailServiceCommand?: ConfigureMailServiceCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.configureMailService(id, configureMailServiceCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.configureMailService']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateOrFixTaxNumberCommand} [createOrFixTaxNumberCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOrFixTaxNumber(createOrFixTaxNumberCommand?: CreateOrFixTaxNumberCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateOrFixTaxNumberResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOrFixTaxNumber(createOrFixTaxNumberCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.createOrFixTaxNumber']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActiveSubscriptions(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActiveSubscriptions(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.getActiveSubscriptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserById(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserReadModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.getUserById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {object} [filter] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [sortAttribute] 
         * @param {SortDirection} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsers(filter?: object, pageNumber?: number, pageSize?: number, sortAttribute?: string, sortDirection?: SortDirection, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserReadModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUsers(filter, pageNumber, pageSize, sortAttribute, sortDirection, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.getUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} [sessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async isUserAuthenticated(id: string, sessionId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.isUserAuthenticated(id, sessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.isUserAuthenticated']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {LoginCommand} [loginCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async login(loginCommand?: LoginCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthenticationResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.login(loginCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.login']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Login2FaCommand} [login2FaCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async login2Fa(login2FaCommand?: Login2FaCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthenticationResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.login2Fa(login2FaCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.login2Fa']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {LogoutCommand} [logoutCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async logout(logoutCommand?: LogoutCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.logout(logoutCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.logout']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} userId 
         * @param {MailServiceConfigTestQuery} [mailServiceConfigTestQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mailServiceConfigTest(userId: string, mailServiceConfigTestQuery?: MailServiceConfigTestQuery, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mailServiceConfigTest(userId, mailServiceConfigTestQuery, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.mailServiceConfigTest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} userId 
         * @param {OrderSubscriptionCommand} [orderSubscriptionCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderSubscription(userId: string, orderSubscriptionCommand?: OrderSubscriptionCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderSubscription(userId, orderSubscriptionCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.orderSubscription']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {RegisterCommand} [registerCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async register(registerCommand?: RegisterCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.register(registerCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.register']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {RemoveLogoCommand} [removeLogoCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeLogo(id: string, removeLogoCommand?: RemoveLogoCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadedFileWithContent>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeLogo(id, removeLogoCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.removeLogo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {RemoveMailServiceConfigurationCommand} [removeMailServiceConfigurationCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeMailServiceConfiguration(id: string, removeMailServiceConfigurationCommand?: RemoveMailServiceConfigurationCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeMailServiceConfiguration(id, removeMailServiceConfigurationCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.removeMailServiceConfiguration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {RemoveTextModelCommand} [removeTextModelCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeTextModel(id: string, removeTextModelCommand?: RemoveTextModelCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AbstractModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeTextModel(id, removeTextModelCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.removeTextModel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {RemoveTextModelEmailCommand} [removeTextModelEmailCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeTextModelEmail(id: string, removeTextModelEmailCommand?: RemoveTextModelEmailCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AbstractModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeTextModelEmail(id, removeTextModelEmailCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.removeTextModelEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ResetPasswordCommand} [resetPasswordCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetPassword(resetPasswordCommand?: ResetPasswordCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetPassword(resetPasswordCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.resetPassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SendPasswordResetMailCommand} [sendPasswordResetMailCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendPasswordResetMail(sendPasswordResetMailCommand?: SendPasswordResetMailCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendPasswordResetMail(sendPasswordResetMailCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.sendPasswordResetMail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SetupUserLoginCommand} [setupUserLoginCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setupUserLogin(setupUserLoginCommand?: SetupUserLoginCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SetupUserLoginResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setupUserLogin(setupUserLoginCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.setupUserLogin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateUserCommand} [updateUserCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUser(id: string, updateUserCommand?: UpdateUserCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AbstractModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUser(id, updateUserCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.updateUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [taxNumber] 
         * @param {FederalState} [federalState] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateTaxNumber(taxNumber?: string, federalState?: FederalState, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateOrFixTaxNumberResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateTaxNumber(taxNumber, federalState, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.validateTaxNumber']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UsersApi - factory interface
 */
export const UsersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UsersApiFp(configuration)
    return {
        /**
         * 
         * @param {UsersApiAddLogoRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addLogo(requestParameters: UsersApiAddLogoRequest, options?: RawAxiosRequestConfig): AxiosPromise<AbstractModel> {
            return localVarFp.addLogo(requestParameters.id, requestParameters.addLogoCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiAddTextModelRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTextModel(requestParameters: UsersApiAddTextModelRequest, options?: RawAxiosRequestConfig): AxiosPromise<AbstractModel> {
            return localVarFp.addTextModel(requestParameters.id, requestParameters.addTextModelCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiAddTextModelEmailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTextModelEmail(requestParameters: UsersApiAddTextModelEmailRequest, options?: RawAxiosRequestConfig): AxiosPromise<AbstractModel> {
            return localVarFp.addTextModelEmail(requestParameters.id, requestParameters.addTextModelEmailCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiAddUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUser(requestParameters: UsersApiAddUserRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<UserReadModel> {
            return localVarFp.addUser(requestParameters.importUserCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiChangeBookingPeriodRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeBookingPeriod(requestParameters: UsersApiChangeBookingPeriodRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.changeBookingPeriod(requestParameters.changeBookingPeriodCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiConfigureMailServiceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configureMailService(requestParameters: UsersApiConfigureMailServiceRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.configureMailService(requestParameters.id, requestParameters.configureMailServiceCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiCreateOrFixTaxNumberRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrFixTaxNumber(requestParameters: UsersApiCreateOrFixTaxNumberRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<CreateOrFixTaxNumberResult> {
            return localVarFp.createOrFixTaxNumber(requestParameters.createOrFixTaxNumberCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiGetActiveSubscriptionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveSubscriptions(requestParameters: UsersApiGetActiveSubscriptionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.getActiveSubscriptions(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiGetUserByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserById(requestParameters: UsersApiGetUserByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserReadModel> {
            return localVarFp.getUserById(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiGetUsersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsers(requestParameters: UsersApiGetUsersRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<UserReadModel>> {
            return localVarFp.getUsers(requestParameters.filter, requestParameters.pageNumber, requestParameters.pageSize, requestParameters.sortAttribute, requestParameters.sortDirection, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiIsUserAuthenticatedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isUserAuthenticated(requestParameters: UsersApiIsUserAuthenticatedRequest, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.isUserAuthenticated(requestParameters.id, requestParameters.sessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiLoginRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login(requestParameters: UsersApiLoginRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AuthenticationResult> {
            return localVarFp.login(requestParameters.loginCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiLogin2FaRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login2Fa(requestParameters: UsersApiLogin2FaRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AuthenticationResult> {
            return localVarFp.login2Fa(requestParameters.login2FaCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiLogoutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout(requestParameters: UsersApiLogoutRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.logout(requestParameters.logoutCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiMailServiceConfigTestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailServiceConfigTest(requestParameters: UsersApiMailServiceConfigTestRequest, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.mailServiceConfigTest(requestParameters.userId, requestParameters.mailServiceConfigTestQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiOrderSubscriptionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderSubscription(requestParameters: UsersApiOrderSubscriptionRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.orderSubscription(requestParameters.userId, requestParameters.orderSubscriptionCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiRegisterRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        register(requestParameters: UsersApiRegisterRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.register(requestParameters.registerCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiRemoveLogoRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeLogo(requestParameters: UsersApiRemoveLogoRequest, options?: RawAxiosRequestConfig): AxiosPromise<UploadedFileWithContent> {
            return localVarFp.removeLogo(requestParameters.id, requestParameters.removeLogoCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiRemoveMailServiceConfigurationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeMailServiceConfiguration(requestParameters: UsersApiRemoveMailServiceConfigurationRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.removeMailServiceConfiguration(requestParameters.id, requestParameters.removeMailServiceConfigurationCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiRemoveTextModelRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeTextModel(requestParameters: UsersApiRemoveTextModelRequest, options?: RawAxiosRequestConfig): AxiosPromise<AbstractModel> {
            return localVarFp.removeTextModel(requestParameters.id, requestParameters.removeTextModelCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiRemoveTextModelEmailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeTextModelEmail(requestParameters: UsersApiRemoveTextModelEmailRequest, options?: RawAxiosRequestConfig): AxiosPromise<AbstractModel> {
            return localVarFp.removeTextModelEmail(requestParameters.id, requestParameters.removeTextModelEmailCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiResetPasswordRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword(requestParameters: UsersApiResetPasswordRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.resetPassword(requestParameters.resetPasswordCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiSendPasswordResetMailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendPasswordResetMail(requestParameters: UsersApiSendPasswordResetMailRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.sendPasswordResetMail(requestParameters.sendPasswordResetMailCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiSetupUserLoginRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setupUserLogin(requestParameters: UsersApiSetupUserLoginRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<SetupUserLoginResult> {
            return localVarFp.setupUserLogin(requestParameters.setupUserLoginCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiUpdateUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser(requestParameters: UsersApiUpdateUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<AbstractModel> {
            return localVarFp.updateUser(requestParameters.id, requestParameters.updateUserCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiValidateTaxNumberRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateTaxNumber(requestParameters: UsersApiValidateTaxNumberRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<CreateOrFixTaxNumberResult> {
            return localVarFp.validateTaxNumber(requestParameters.taxNumber, requestParameters.federalState, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for addLogo operation in UsersApi.
 */
export interface UsersApiAddLogoRequest {
    readonly id: string

    readonly addLogoCommand?: AddLogoCommand
}

/**
 * Request parameters for addTextModel operation in UsersApi.
 */
export interface UsersApiAddTextModelRequest {
    readonly id: string

    readonly addTextModelCommand?: AddTextModelCommand
}

/**
 * Request parameters for addTextModelEmail operation in UsersApi.
 */
export interface UsersApiAddTextModelEmailRequest {
    readonly id: string

    readonly addTextModelEmailCommand?: AddTextModelEmailCommand
}

/**
 * Request parameters for addUser operation in UsersApi.
 */
export interface UsersApiAddUserRequest {
    readonly importUserCommand?: ImportUserCommand
}

/**
 * Request parameters for changeBookingPeriod operation in UsersApi.
 */
export interface UsersApiChangeBookingPeriodRequest {
    readonly changeBookingPeriodCommand?: ChangeBookingPeriodCommand
}

/**
 * Request parameters for configureMailService operation in UsersApi.
 */
export interface UsersApiConfigureMailServiceRequest {
    readonly id: string

    readonly configureMailServiceCommand?: ConfigureMailServiceCommand
}

/**
 * Request parameters for createOrFixTaxNumber operation in UsersApi.
 */
export interface UsersApiCreateOrFixTaxNumberRequest {
    readonly createOrFixTaxNumberCommand?: CreateOrFixTaxNumberCommand
}

/**
 * Request parameters for getActiveSubscriptions operation in UsersApi.
 */
export interface UsersApiGetActiveSubscriptionsRequest {
    readonly id: string
}

/**
 * Request parameters for getUserById operation in UsersApi.
 */
export interface UsersApiGetUserByIdRequest {
    readonly id: string
}

/**
 * Request parameters for getUsers operation in UsersApi.
 */
export interface UsersApiGetUsersRequest {
    readonly filter?: object

    readonly pageNumber?: number

    readonly pageSize?: number

    readonly sortAttribute?: string

    readonly sortDirection?: SortDirection
}

/**
 * Request parameters for isUserAuthenticated operation in UsersApi.
 */
export interface UsersApiIsUserAuthenticatedRequest {
    readonly id: string

    readonly sessionId?: string
}

/**
 * Request parameters for login operation in UsersApi.
 */
export interface UsersApiLoginRequest {
    readonly loginCommand?: LoginCommand
}

/**
 * Request parameters for login2Fa operation in UsersApi.
 */
export interface UsersApiLogin2FaRequest {
    readonly login2FaCommand?: Login2FaCommand
}

/**
 * Request parameters for logout operation in UsersApi.
 */
export interface UsersApiLogoutRequest {
    readonly logoutCommand?: LogoutCommand
}

/**
 * Request parameters for mailServiceConfigTest operation in UsersApi.
 */
export interface UsersApiMailServiceConfigTestRequest {
    readonly userId: string

    readonly mailServiceConfigTestQuery?: MailServiceConfigTestQuery
}

/**
 * Request parameters for orderSubscription operation in UsersApi.
 */
export interface UsersApiOrderSubscriptionRequest {
    readonly userId: string

    readonly orderSubscriptionCommand?: OrderSubscriptionCommand
}

/**
 * Request parameters for register operation in UsersApi.
 */
export interface UsersApiRegisterRequest {
    readonly registerCommand?: RegisterCommand
}

/**
 * Request parameters for removeLogo operation in UsersApi.
 */
export interface UsersApiRemoveLogoRequest {
    readonly id: string

    readonly removeLogoCommand?: RemoveLogoCommand
}

/**
 * Request parameters for removeMailServiceConfiguration operation in UsersApi.
 */
export interface UsersApiRemoveMailServiceConfigurationRequest {
    readonly id: string

    readonly removeMailServiceConfigurationCommand?: RemoveMailServiceConfigurationCommand
}

/**
 * Request parameters for removeTextModel operation in UsersApi.
 */
export interface UsersApiRemoveTextModelRequest {
    readonly id: string

    readonly removeTextModelCommand?: RemoveTextModelCommand
}

/**
 * Request parameters for removeTextModelEmail operation in UsersApi.
 */
export interface UsersApiRemoveTextModelEmailRequest {
    readonly id: string

    readonly removeTextModelEmailCommand?: RemoveTextModelEmailCommand
}

/**
 * Request parameters for resetPassword operation in UsersApi.
 */
export interface UsersApiResetPasswordRequest {
    readonly resetPasswordCommand?: ResetPasswordCommand
}

/**
 * Request parameters for sendPasswordResetMail operation in UsersApi.
 */
export interface UsersApiSendPasswordResetMailRequest {
    readonly sendPasswordResetMailCommand?: SendPasswordResetMailCommand
}

/**
 * Request parameters for setupUserLogin operation in UsersApi.
 */
export interface UsersApiSetupUserLoginRequest {
    readonly setupUserLoginCommand?: SetupUserLoginCommand
}

/**
 * Request parameters for updateUser operation in UsersApi.
 */
export interface UsersApiUpdateUserRequest {
    readonly id: string

    readonly updateUserCommand?: UpdateUserCommand
}

/**
 * Request parameters for validateTaxNumber operation in UsersApi.
 */
export interface UsersApiValidateTaxNumberRequest {
    readonly taxNumber?: string

    readonly federalState?: FederalState
}

/**
 * UsersApi - object-oriented interface
 */
export class UsersApi extends BaseAPI {
    /**
     * 
     * @param {UsersApiAddLogoRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addLogo(requestParameters: UsersApiAddLogoRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).addLogo(requestParameters.id, requestParameters.addLogoCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiAddTextModelRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addTextModel(requestParameters: UsersApiAddTextModelRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).addTextModel(requestParameters.id, requestParameters.addTextModelCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiAddTextModelEmailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addTextModelEmail(requestParameters: UsersApiAddTextModelEmailRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).addTextModelEmail(requestParameters.id, requestParameters.addTextModelEmailCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiAddUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addUser(requestParameters: UsersApiAddUserRequest = {}, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).addUser(requestParameters.importUserCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiChangeBookingPeriodRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public changeBookingPeriod(requestParameters: UsersApiChangeBookingPeriodRequest = {}, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).changeBookingPeriod(requestParameters.changeBookingPeriodCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiConfigureMailServiceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public configureMailService(requestParameters: UsersApiConfigureMailServiceRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).configureMailService(requestParameters.id, requestParameters.configureMailServiceCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiCreateOrFixTaxNumberRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createOrFixTaxNumber(requestParameters: UsersApiCreateOrFixTaxNumberRequest = {}, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).createOrFixTaxNumber(requestParameters.createOrFixTaxNumberCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiGetActiveSubscriptionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getActiveSubscriptions(requestParameters: UsersApiGetActiveSubscriptionsRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).getActiveSubscriptions(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiGetUserByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getUserById(requestParameters: UsersApiGetUserByIdRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).getUserById(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiGetUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getUsers(requestParameters: UsersApiGetUsersRequest = {}, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).getUsers(requestParameters.filter, requestParameters.pageNumber, requestParameters.pageSize, requestParameters.sortAttribute, requestParameters.sortDirection, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiIsUserAuthenticatedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public isUserAuthenticated(requestParameters: UsersApiIsUserAuthenticatedRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).isUserAuthenticated(requestParameters.id, requestParameters.sessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiLoginRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public login(requestParameters: UsersApiLoginRequest = {}, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).login(requestParameters.loginCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiLogin2FaRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public login2Fa(requestParameters: UsersApiLogin2FaRequest = {}, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).login2Fa(requestParameters.login2FaCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiLogoutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public logout(requestParameters: UsersApiLogoutRequest = {}, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).logout(requestParameters.logoutCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiMailServiceConfigTestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mailServiceConfigTest(requestParameters: UsersApiMailServiceConfigTestRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).mailServiceConfigTest(requestParameters.userId, requestParameters.mailServiceConfigTestQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiOrderSubscriptionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public orderSubscription(requestParameters: UsersApiOrderSubscriptionRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).orderSubscription(requestParameters.userId, requestParameters.orderSubscriptionCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiRegisterRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public register(requestParameters: UsersApiRegisterRequest = {}, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).register(requestParameters.registerCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiRemoveLogoRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public removeLogo(requestParameters: UsersApiRemoveLogoRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).removeLogo(requestParameters.id, requestParameters.removeLogoCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiRemoveMailServiceConfigurationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public removeMailServiceConfiguration(requestParameters: UsersApiRemoveMailServiceConfigurationRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).removeMailServiceConfiguration(requestParameters.id, requestParameters.removeMailServiceConfigurationCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiRemoveTextModelRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public removeTextModel(requestParameters: UsersApiRemoveTextModelRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).removeTextModel(requestParameters.id, requestParameters.removeTextModelCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiRemoveTextModelEmailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public removeTextModelEmail(requestParameters: UsersApiRemoveTextModelEmailRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).removeTextModelEmail(requestParameters.id, requestParameters.removeTextModelEmailCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiResetPasswordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public resetPassword(requestParameters: UsersApiResetPasswordRequest = {}, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).resetPassword(requestParameters.resetPasswordCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiSendPasswordResetMailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public sendPasswordResetMail(requestParameters: UsersApiSendPasswordResetMailRequest = {}, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).sendPasswordResetMail(requestParameters.sendPasswordResetMailCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiSetupUserLoginRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public setupUserLogin(requestParameters: UsersApiSetupUserLoginRequest = {}, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).setupUserLogin(requestParameters.setupUserLoginCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiUpdateUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateUser(requestParameters: UsersApiUpdateUserRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).updateUser(requestParameters.id, requestParameters.updateUserCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiValidateTaxNumberRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateTaxNumber(requestParameters: UsersApiValidateTaxNumberRequest = {}, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).validateTaxNumber(requestParameters.taxNumber, requestParameters.federalState, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * VersionsApi - axios parameter creator
 */
export const VersionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuthenticationServiceVersion: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Versions/AuthenticationService`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFileServiceVersion: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Versions/FileService`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFreeBillServiceVersion: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Versions/FreeBill`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VersionsApi - functional programming interface
 */
export const VersionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VersionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAuthenticationServiceVersion(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAuthenticationServiceVersion(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VersionsApi.getAuthenticationServiceVersion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFileServiceVersion(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFileServiceVersion(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VersionsApi.getFileServiceVersion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFreeBillServiceVersion(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFreeBillServiceVersion(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VersionsApi.getFreeBillServiceVersion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * VersionsApi - factory interface
 */
export const VersionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VersionsApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuthenticationServiceVersion(options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.getAuthenticationServiceVersion(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFileServiceVersion(options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.getFileServiceVersion(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFreeBillServiceVersion(options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.getFreeBillServiceVersion(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VersionsApi - object-oriented interface
 */
export class VersionsApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAuthenticationServiceVersion(options?: RawAxiosRequestConfig) {
        return VersionsApiFp(this.configuration).getAuthenticationServiceVersion(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getFileServiceVersion(options?: RawAxiosRequestConfig) {
        return VersionsApiFp(this.configuration).getFileServiceVersion(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getFreeBillServiceVersion(options?: RawAxiosRequestConfig) {
        return VersionsApiFp(this.configuration).getFreeBillServiceVersion(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * XmlInvoicesApi - axios parameter creator
 */
export const XmlInvoicesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {GetXmlInvoiceFromFileQuery} [getXmlInvoiceFromFileQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getXmlInvoice: async (getXmlInvoiceFromFileQuery?: GetXmlInvoiceFromFileQuery, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/XmlInvoices/GetXmlInvoice`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getXmlInvoiceFromFileQuery, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * XmlInvoicesApi - functional programming interface
 */
export const XmlInvoicesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = XmlInvoicesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {GetXmlInvoiceFromFileQuery} [getXmlInvoiceFromFileQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getXmlInvoice(getXmlInvoiceFromFileQuery?: GetXmlInvoiceFromFileQuery, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<XmlInvoiceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getXmlInvoice(getXmlInvoiceFromFileQuery, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['XmlInvoicesApi.getXmlInvoice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * XmlInvoicesApi - factory interface
 */
export const XmlInvoicesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = XmlInvoicesApiFp(configuration)
    return {
        /**
         * 
         * @param {XmlInvoicesApiGetXmlInvoiceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getXmlInvoice(requestParameters: XmlInvoicesApiGetXmlInvoiceRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<XmlInvoiceDto> {
            return localVarFp.getXmlInvoice(requestParameters.getXmlInvoiceFromFileQuery, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getXmlInvoice operation in XmlInvoicesApi.
 */
export interface XmlInvoicesApiGetXmlInvoiceRequest {
    readonly getXmlInvoiceFromFileQuery?: GetXmlInvoiceFromFileQuery
}

/**
 * XmlInvoicesApi - object-oriented interface
 */
export class XmlInvoicesApi extends BaseAPI {
    /**
     * 
     * @param {XmlInvoicesApiGetXmlInvoiceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getXmlInvoice(requestParameters: XmlInvoicesApiGetXmlInvoiceRequest = {}, options?: RawAxiosRequestConfig) {
        return XmlInvoicesApiFp(this.configuration).getXmlInvoice(requestParameters.getXmlInvoiceFromFileQuery, options).then((request) => request(this.axios, this.basePath));
    }
}



